export const WorkCommitteeList = [
  '学术工作委员会',
  '科普工作委员会',
  '咨询工作委员会',
  '组织工作委员会',
  '教育委员会',
  '青年工作委员会',
  '青少年工作委员会',
  '产学研用促进中心',
  '标准工作委员会',
];
export const SpecialtyCommitteeList = [
  '计算机视觉专业委员会',
  '自然语言处理专委会',
  '人工智能专业委员会',
  '生物信息学专业委员会',
  '协同与信息服务专业委员会',
  '存储专业委员会',
  '网络专业委员会',
  '多媒体专业委员会',
  '系统结构专业委员会',
  '软件工程专业委员会',
  '物联网专业委员会',
  '信息安全专业委员会',
  '理论计算机科学专业委员会',
  '普适计算与嵌入式专业委员会',
  '数据库专业委员会',
  '教育信息化专业委员会',
  '高性能计算专业委员会',
  '金融科技专业委员会',
];
export interface ISpecialtyCommittee {
  name: string;
  description: string;
  list: {
    title: string;
    members: {
      name: string;
      group: string;
      email: string;
      description: string;
    }[];
  }[];
}
export const SpecialtyCommitteeInfoList: ISpecialtyCommittee[] = [
  {
    name: '计算机视觉专业委员会',
    description:
      '上海市计算机学会计算机视觉专业委员会的宗旨是立足上海，覆盖长三角，辐射全国，促进和推动本市计算机视觉理论和技术的发展及应用。2021年筹办，2022年上海市计算机学会正式批复成立。专委会班子成员由1位主任委员、5位副主任委员和1位秘书长组成。2024年专委会正式成立秘书处，协助专委班子开展各项工作。专委会已形成“上海市计算机学会计算机视觉学术年会”“CVPR上海论文分享学术报告会”“上海计算机视觉大讲堂”三个品牌活动，同时还有科研速递、走进校企和科普教育等系列活动。专委会曾获2023年度上海市计算机学会优秀专委会。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '赵才荣',
            group: '同济大学',
            email: 'zhaocairong@tongji.edu.cn',
            description:
              '赵才荣，博士，同济大学计算机科学与技术学院教授，博士生导师。曾任香港理工大学兼职研究员（2016-2017）。目前担任上海市计算机学会计算机视觉专委会主任，中国图象图形学学会青工委秘书长，中国计算机学会杰出会员。研究兴趣：计算机视觉，主要聚焦于智能视频行人分析及其隐私安全研究，重点研究高效可信行人再识别、多模态数据驱动的自动驾驶以及垂直领域模型的知识表示与推理问题。已在TPAMI、IJCV、IEEE TIP、IEEE TIFS、中国科学.信息科学等国内外重要学术期刊及国际学术会议CVPR，ICML，ICLR，AAAI，ACM MM等发表论文50余篇，受理发明专利20余项（授权18项），研究成果获2023年上海市自然科学奖二等奖（序1）、2022年上海市科技进步奖一等奖（序4）。主持国家自然科学基金4项，主持国家重点研发计划子课题以及企业横向课题十余项。建设国家级线下精品课程1门，上海市精品课程1门。指导学生获中国电子学会优秀硕士论文、上海市计算机学会优秀硕士论文。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '周日贵',
            group: '上海海事大学',
            email: 'rgzhou@shmtu.edu.cn',
            description:
              '周日贵，博士，上海海事大学二级教授，博士生导师，信息工程学院院长。十三五和十四五国家重点研发计划项目负责人（首席科学家），东方英才上海领军人才，教育部新世纪优秀人才，交通运输部中青年科技创新领军人才，入选全球前2%“顶尖科学家”榜单。主持国家重点研发计划项目和课题各二项、国家自然科学基金四项、教育部科学技术重点项目等省级科研项目二十多项；近年来在IEEE TIP、IEEE TNNLS、IEEE TFS、IEEE TETC、CVPR等国际顶级期刊和会议上发表第一及通信作者学术论文165篇，获上海市科技进步奖等省部奖四项，第六届、八届吴文俊人工智能科学技术奖二项，获第22届中国国际工业博览会高校展区“优秀展品奖”，出版学术专著四部，其中三部全英文学术专著，获发明专利5项，牵头制定行业标准2项，团体标准1项。；担任第二届智能科学国际会议大会执行主席、第一届量子世界大会主题论坛主席和分论坛主席。',
          },
          {
            name: '付彦伟',
            group: '复旦大学',
            email: 'yanweifu@fudan.edu.cn',
            description:
              '付彦伟，博士，复旦大学大数据学院教授，博士生导师，国家级青年人才，上海高校特聘教授 (即东方学者)，英国计算机协会会士（BCS Fellow）。2014年获得伦敦大学玛丽皇后学院博士学位，2015-2016年在美国匹兹堡迪士尼研究院任博士后研究员。研究方向侧重于基于迁移学习的多个任务，如零样本/小样本学习；3D/4D物体的建模；神经网络稀疏化学习、机械臂抓取；fMRI Neural Decoding等。发表高水平论文150多篇，其中计算机视觉与模式识别顶级期刊IEEE TPAMI通讯作者/第一作者论文15篇，曾获IEEE ICME 2019最佳论文。获美国发明专利7项、中国专利20多项。',
          },
          {
            name: '沈为',
            group: '上海交通大学',
            email: 'wei.shen@sjtu.edu.cn',
            description:
              '沈 为，博士，上海交通大学人工智能研究院教授，博士生导师，国家自然科学基金优青获得者。曾任约翰霍普金斯大学计算机系助理研究教授。研究方向为计算机视觉、深度学习与医学图像处理。在人工智能领域的顶级学术会议和期刊上发表论文80余篇，总学术引用1万多次。指导博士生论文获得医学图像处理顶级国际会议MICCAI 2023青年科学家奖。担任人工智能领域顶级国际会议ICML 2025、ICCV 2025、NeurIPS 2023/2024、CVPR 2022/2023领域主席、SCI一区期刊Pattern Recognition编委。',
          },
          {
            name: '李东胜',
            group: '微软亚洲研究院',
            email: 'dongshengli@fudan.edu.cn',
            description:
              '李东胜，博士，微软亚洲研究院（上海）首席研究员，上海人工智能组研究经理，复旦大学计算机学院客座教授、兼职博士生导师，中国计算机学会协同计算专业委员会执委，上海计算机学会计算机视觉专业委员会副主任。主要研究方向为机器学习算法及其在脑科学和医疗健康领域的应用，在相关领域的知名期刊和会议发表论文200余篇，出版专著2部。曾获得IBM最高技术奖项IBM Corporate Award，被《麻省理工科技评论》中国与DeepTech评选为“2023年中国智能计算创新人物”。',
          },
          {
            name: '曾丹',
            group: '上海大学',
            email: 'dzeng@shu.edu.cn',
            description:
              '曾丹，博士，上海大学教授，通信工程系系主任，国家级青年人才。兼任IEEE TMM、IEEE TCSVT编委、IEEE第24届国际多媒体信号处理会议程序委员会主席、IEEE多媒体系统及应用技术委员会委员、IEEE多媒体信号处理专业委员会委员、IEEE高级会员、中国通信学会青工委委员等；曾任中国计算机学会CTO CLUB（上海）副主席、IEEE第23届国际多媒体信号处理会议程序委员会主席。研究领域为计算机视觉、多媒体内容分析和模式识别，重点从探索目标感知中的探测、检测、识别与定位的新方法及新方案出发，解决复杂场景下低质量目标实时智能感知及应用中的关键技术难题。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '张志飞',
            group: '同济大学',
            email: 'zhifeizhang@tongji.edu.cn',
            description:
              '张志飞，博士，同济大学计算机科学与技术学院博士生导师。曾任加拿大蒙特利尔大学博士后研究员（2014-2015）。目前担任上海市计算机学会计算机视觉专委会秘书长、中国人工智能学会粒计算与知识发现专委会委员、中国中文信息学会情感计算专委会委员。主要从事不确定性与大数据挖掘的研究，主持国家自然科学基金、上海市自然科学基金等项目，在IEEE TGRS、CAAI TRIT、ESWA、计算机研究与发展等期刊会议上发表论文30余篇，出版教材/著作2部。作为骨干，获吴文俊人工智能自然科学奖二等奖、上海市科技进步奖二等奖，建设国家级一流本科课程《人工智能原理》和《中文信息处理》。',
          },
        ],
      },
    ],
  },
  {
    name: '自然语言处理专委会',
    description:
      '团结、联合和组织本市及长三角地区自然语言处理技术相关领域的各界专业人士，开展学术/技术交流、发展战略研究、专业技术标准制定、专业技术评测、专业培训等相关活动，提高本市自然语言处理领域的科研、教学和应用水平，促进研究成果向产品应用转化，提升在国家科技活动和国际学术方面的影响力。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '邱锡鹏',
            group: '复旦大学',
            email: 'xpqiu@fudan.edu.cn',
            description:
              '邱锡鹏，复旦大学/上海创智学院教授，中国人工智能学会会士，担任中国中文信息学会大模型与生成专委会副主任、中国人工智能学会自然语言理解专委会副主任，入选中国高被引学者和全球前2%顶尖科学家榜单、教育部“高校计算机专业优秀教师奖励计划”等，获钱伟长中文信息处理科学技术奖一等奖（第一完成人）、CCF-ACM青年科技奖等奖励，曾主持上海基础特区、国家优青、科技创新2030重大项目课题等项目。主持研发了多个高影响力大模型MOSS、SpeechGPT、AnyGPT、InternLM。著作《神经网络与深度学习》被上百家高校作为教材。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '张伟楠',
            group: '上海交通大学',
            email: 'wnzhang@sjtu.edu.cn ',
            description:
              '张伟楠，博士，现任上海交通大学计算机系教授、博士生导师、副系主任，科研领域包括强化学习、决策大模型、智能体技术、具身智能，发表CCF-A类国际会议和期刊100余篇学术论文，谷歌学术引用2.5万余次，H指数72，爱思唯尔中国高被引学者，获得5个最佳论文奖项，出版教材《动手学强化学习》等。张伟楠长期担任NeurIPS、ICML、ICLR等会议的领域主席和TPAMI等期刊的编委，作为负责人承担国自然优青项目和科技部重大项目课题，获得吴文俊优青奖和达摩院青橙奖。张伟楠于2011年获得上海交通大学计算机系ACM班学士学位，于2016年获得伦敦大学学院计算机系博士学位。',
          },
          {
            name: '王昊奋',
            group: '同济大学',
            email: 'haofen.wang@tongji.edu.cn',
            description:
              '王昊奋，同济大学百人计划特聘研究员，博士生导师。他是全球最大的中文开放知识图谱联盟OpenKG轮值主席。他负责主持多项国家AI专项，发表100余篇AI领域高水平论文。他构建了全球首个可交互养成的虚拟偶像—“琥珀·虚颜”；所构建的智能客服机器人已累计服务用户超过10亿人次。目前，他担任中国计算机学会术语工委副主任，自然语言处理专委秘书长，信息系统专委常委，智能机器人专委会执委；中国中文信息学会理事，大模型专委会指导委员会委员，语言与知识计算专委会副秘书长；中国指挥控制学会大模型专委会常务委员；上海市计算机学会自然语言处理专委会副主任等社会职位。',
          },
          {
            name: '彭俊杰',
            group: '上海大学',
            email: 'jjie.peng@shu.edu.cn',
            description:
              '彭俊杰，博士，上海大学教授/博导，CCF智能机器人专委会执委，上海市计算机学会理事、副秘书长，安徽工业大学工商学院客座教授。主要研究方向计算机视觉、自然语言处理、多模态分析、智能技术与系统、云计算存储与节能等。主持国家级、省部级及企业委托项目30余项；申请专利45项，授权33项（其中含美国专利2项、中国发明专利17项）。出版学术专著一部，在包括IEEE TOC、IEEE TAFFC、ACM TALLIP、Science China、中国科学：信息科学等行业领域著名期刊及会议上发表学术论文130余篇。现为科技部专家、上海市科技专家，曾任CCF YOCSEF上海主席、中国云计算专家咨询委员会专家。曾获中国产学研合作创新奖、中国人工智能学会青年科技成果奖、上海市教学成果一等奖、上海市计算机学会自然科学奖二等奖、上海市研究生优秀学位论文指导教师等荣誉。',
          },
          {
            name: '吴苑斌',
            group: '华东师范大学',
            email: 'ybwu@cs.ecnu.edu.cn',
            description:
              '吴苑斌，博士，华东师范大学计算机学院副教授。主要研究方向为结构化学习与模型可解释性。2012年获得复旦大学博士学位。2013年新加坡国立大学研究员。主要研究工作发表于自然语言处理与机器学习领域主流国际期刊与会议(ACL，EMNLP，ICML，NeurIPS等)。主持国家自然科学基金、上海市自然科学基金等科研项目多项。',
          },
          {
            name: '沈李斌',
            group: '上海乐言科技股份有限公司',
            email: 'libin@leyantech.com',
            description:
              '沈李斌，博士，上海乐言科技股份有限公司创始人和CEO，正高级工程师，乐言科技是一家领先的人工智能企业。沈李斌本科及硕士毕业于上海交通大学，博士毕业于宾夕法尼亚大学，自然语言处理和机器学习方向。毕业之后，他先后在BBN、Akamai、IBM等机构任职。他曾在ACL、NAACL、EMNLP、CLJ、MLJ等会议和期刊上发表论文20余篇，专注的领域包括机器翻译、句法分析、对话系统等，曾获ACL 2008最佳论文奖，也是第一位中国人获此殊荣，目前也是中国中文信息学会理事和中国语文现代化学会理事。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '陈琴',
            group: '华东师范大学',
            email: 'qchen@cs.ecnu.edu.cn',
            description:
              '陈琴，博士，华东师范大学计算机科学与技术学院青年研究员、博士生导师。主要研究方向为信息检索、知识抽取、人机问答和对话系统。目前致力于大语言模型在教育垂直领域的技术探索，并作为项目主要负责人之一，研发了教育垂直领域大模型EduChat和小花狮心理辅导机器人，并获得上海开源创新卓越成果奖特等奖。在相关领域国际重要会议和期刊如TKDE、AAAI、IJCAI、SIGIR、EMNLP等发表论文50余篇，作为负责人主持国家自然科学基金、科技部重大项目课题、上海市科委AI专项等科研项目多项，获得上海市技术发明奖一等奖（排名第9），常年担任相关学术会议和期刊审稿人，并在多个国际会议如EMNLP、NLPCC等担任领域主席。',
          },
        ],
      },
    ],
  },
  {
    name: '人工智能专业委员会',
    description:
      '上海市计算机学会人工智能专委会是一个开放的专业交流平台，致力于推动人工智能领域的学术研究、技术应用和人才培养。专委会汇聚了来自高校、科研机构和企业的专家学者，涵盖机器学习、计算机视觉、自然语言处理等多个前沿方向。通过举办高水平学术论坛和研讨会，专委会为学术界和产业界搭建深度交流的桥梁，促进技术的创新发展。在人才培养方面，专委会积极开展学术交流活动，为青年学者提供与顶尖专家交流的机会，助力其成长，并通过组织竞赛和培训激发青少年的创新热情。同时，专委会积极推动产学研合作，助力人工智能赋能传统产业，推动产业升级。未来，专委会将继续发挥桥梁作用，促进学术研究与产业应用的深度融合，推动上海乃至全国人工智能技术的发展。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '孙仕亮',
            group: '上海交通大学',
            email: 'shiliangsun@gmail.com',
            description:
              '孙仕亮，博士，上海交通大学电子信息与电气工程学院教授，华东师范大学模式识别与机器学习研究小组创始负责人。博士毕业于清华大学，曾在University College London，Columbia University等海外高校从事访问研究。主要研究方向为机器学习、人工智能，迄今发表学术论文200多篇。担任IEEE TPAMI、IEEE TNNLS、自动化学报等知名期刊编委。曾获中国自动化学会自然科学奖一等奖等重要奖项。出版多部学术专著和教科书，如《Multiview Machine Learning》、《模式识别与机器学习》等。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '单洪明',
            group: '复旦大学',
            email: 'hmshan@fudan.edu.cn',
            description:
              '单洪明，国家海外高层次青年人才计划，复旦大学类脑智能科学与技术研究院研究员、博士生导师。博士毕业于复旦大学计算机科学技术学院，随后在美国伦斯勒理工学院生物医学影像中心先后担任博士后和研究科学家。主要研究方向为机器学习、医学成像、图像处理等。先后在Nature Machine Intelligence、Nature Communications、IEEE TPAMI、IEEE SPM、IEEE TMI、IEEE TIP、MedIA、ICCV、CVPR、NeurIPS等国际期刊和会议发表论文100余篇，谷歌学术引用5000余次；论文入选世界人工智能大会青年优秀论文奖、ESI高被引论文、中国社会计算会议最佳论文。主持国家自然科学基金优青（海外）项目、面上项目等多项科研项目。',
          },
          {
            name: '王振超',
            group: '北京钢铁侠科技有限公司',
            email: '13671944940@1396.com',
            description:
              '王振超，北京钢铁侠科技有限公司联合创始人，国家地方共建人形机器人创新中心监事，是智能机器人与人工智能领域的杰出专家，专注于机器人及人工智能项目的应用落地，以其深厚的专业背景和丰富的实战经验，在行业内享有盛誉。同时作为中国机器人CR教育培训标准委员会成员、中国智能机器人大赛评委，积极参与行业标准的制定与优秀项目的评选。还担任上海信息学校工业机器人专业方向产业导师、天津职业技术师范大学机电学院特聘研究生产业讲师，致力于培养适应未来需求的智能机器人技术人才。凭借在智能机器人领域的卓越贡献，荣获上海市宝山区第六届“宝山工匠”（智能机器人方向）、友谊工匠称号。此外，还参与了《上海市职业院校智能机器人技术专业实训教学环境建设指南》的编写，为推动智能机器人技术的发展做出了重要贡献。',
          },
          {
            name: '殷俊',
            group: '上海海事大学',
            email: 'junyin@shmtu.edu.cn',
            description:
              '殷俊，博士，上海海事大学信息工程学院副教授，上海市浦江人才。分别于2006年、2011年获得南京理工大学学士、博士学位，2016~2020年在华东师范大学从事博士后研究，2019~2020年在美国匹兹堡大学访问。主要研究方向是多视图学习、对比学习等机器学习理论及应用。目前担任国际期刊Expert Systems and Applications、Neural Processing Letters编委、上海市计算机学会人工智能专委会副主任。在IEEE TKDE、IEEE TNNLS、PR、Information Fusion等国际期刊以及AAAI、ACM MM等国际会议上发表论文50余篇，获2023年度中国自动化学会自然科学一等奖（排名第四）、2023年度IEEE TNNLS杰出论文奖。主持国家自然科学基金面上/青年项目、上海市自然科学基金青年项目、中国博士后科学基金面上项目。',
          },
          {
            name: '岳晓冬',
            group: '上海大学未来技术学院（人工智能研究院）',
            email: 'yswantfly@shu.edu.cn',
            description:
              '岳晓冬，教授、博导，现任上海大学未来技术学院（人工智能研究院）副院长、卓越工程师学院副院长。博士毕业于同济大学，曾于澳大利亚悉尼科技大学任博士后研究员，香港浸会大学、香港理工大学任访问研究员。从事人工智能理论与应用研究，研究方向为机器学习与不确定性决策。发表论文100余篇，其中50余篇中科院或中国计算机学会（CCF）1-2区期刊、会议论文。主持/完成4项国家自科基金项目，骨干参与/完成7项国家级科研项目，包括多项国家自然科学基金与科技部项目。现为IEEE计算智能学会成员，国际粗糙集学会成员、国际信任函数与应用学会成员，中国人工智能学会（CAAI）粒计算与知识发现专委会副主任、机器学习专委会委员，上海市计算机学会人工智能专委会副主任。担任IJAR等多个高水平学术期刊领域编辑及编委。长期担任AAAI等学术会议程序委员会成员，曾任ICME2012、DSAA2014等会议出版主席，Belief2020与IJCRS2022会议副主席。作为团队骨干荣获中国计算机学会科技进步一等奖、上海市优秀教学成果二等奖。',
          },
          {
            name: '赵晓丽',
            group: '上海工程技术大学',
            email: 'evawhy@163.com',
            description:
              '赵晓丽，博士，上海工程技术大学教授，硕士研究生导师。上海市计算机学会人工智能专委会副主任，上海市图像图形学会理事、标准化委员会副主任，中国图象图形学学会多媒体专委会委员。曾于2014.9-2015.9在美国加州大学圣巴巴拉分校计算机科学系4eyes实验室做高级访问学者。主持国家自然科学基金面上项目、上海市科委科技创新行动计划等项目，作为课题执行人参与科技部重大项目、国家重点研发计划；主持获批中国图象图形学学会科技进步二等奖；主持单批25万元科技成果转化，牵头制定团体标准1项，参与标准多项。出版专著1本。主持上海市一流本科课程1门。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '赵静',
            group: '华东师范大学',
            email: 'jzhao@cs.ecnu.edu.cn',
            description:
              '赵静，博士，华东师范大学计算机科学与技术学院副研究员，模式识别与机器学习团队负责人。博士毕业于华东师范大学计算机科学与技术系，研究方向为多模态机器学习。共发表学术论文50余篇，其中CCF A类或中科院一区论文25篇，ESI高被引论文2篇。曾获中国自动化学会自然科学奖一等奖，上海市自然科学奖二等奖等科研奖励。入选上海市 “扬帆计划”和 “晨光计划”。担任Neurocomputing和International Journal of Machine Learning and Cybernetics期刊编委。出版教材《模式识别与机器学习》。',
          },
        ],
      },
    ],
  },
  {
    name: '生物信息学专业委员会',
    description:
      '生物信息学是一门融合了信息科学和生物学的跨学科领域，致力于利用计算机和人工智能等先进技术，来解决生物学领域的各种复杂问题。通过开发高性能的软件工具、数据库系统和计算平台，生物信息学为突破重大生命科学难题和推进生物医药工程项目提供了强大的技术支撑。随着计算科学与生命科学的日益融合，以及生物大数据和人工智能时代的到来，上海市计算机学会生物信息学专业委员会应运而生。\n' +
      '目前专委会领导机构由1名主任委员、3名副主任委员、1名秘书长组成。该委员会的成立旨在聚集上海市生物信息学领域的研究力量，提升上海市生物信息学同行在该领域的研究水平和国际影响力。同时，委员会也致力于促进上海市生物信息学同行之间的学术交流与合作，加强学术界与产业界的紧密联系，探索生物信息学教育的创新模式，培养具有跨学科背景和创新能力的高端人才。通过上海市计算机学会生物信息学专业委员会的不懈努力，上海市同仁将在这一前沿交叉领域取得更多突破性进展，为人类健康和生命科学的发展做出更大贡献。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '赵兴明',
            group: '复旦大学',
            email: 'xmzhao@fudan.edu.cn',
            description:
              '赵兴明，上海市计算机学会生物信息学专委会主任。复旦大学类脑智能科学与技术研究院特聘教授，中山医院双聘教授，类脑智能科学与技术研究院副院长、计算神经科学与类脑智能教育部重点实验室副主任、上海市生物信息学会理事长，张江国际脑库执行主任、国家自然基金杰出青年基金获得者、上海市青年科技启明星和上海市浦江人才计划入选者、IEEE Senior Member、CCF 高级会员、中国人工智能学会人工生命与生物信息学专委会副主任、中国计算机学会生物信息学专委会常务委员和ACM SIGBio China Vice Chair 等。承担了863、国家重点研发计划、国家自然科学基金重大研究计划和重点项目在内的多项科研课题。在Nature、Cell Metabolism、Nature Communications、Genome Medicine、Nucleic Acids Research等国际著名期刊发表SCI论文100余篇，曾获吴文俊人工智能自然科学奖一等奖和教育部自然科学二等奖。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '刘琦',
            group: '同济大学',
            email: 'qiliu@tongji.edu.cn',
            description:
              '刘琦，上海市计算机学会生物信息学专委会副主任。同济大学生命科学与技术学院生物信息系长聘特聘教授，博士生导师，同济大学上海自主智能无人系统科学中心PI。国家杰出青年科学基金项目获得者，教育部青年长江学者。长期致力于发展人工智能技术赋能组学解析和精准干预，进行数据驱动的精准医学研究和转化（“AI for Precision Medicine”），聚焦于面向重大疾病（如肿瘤）的精准药物诊疗，精准细胞治疗和精准基因编辑。在智能计算方法学领域顶刊Nature Methods, Nature Machine Intelligence，Nature Computational Science等及计算机科学领域高影响力的期刊和会议如IEEE TKDE/SDM/ICDM/MICCAI等发表论文，受邀在Trends和WIREs系列等发表综述。其成果获相应期刊Research Highlight、F1000推荐、ESI高引、中国生物信息学算法十大进展等。著《组学机器学习》（科学出版社，2023）。任ELSEVIER出版社人工智能生命科学交叉领域期刊Artificial Intelligence in the Life Sciences创刊编委，中国计算机学会杰出会员。曾入选《麻省理工科技评论》中国智能计算创新人物、获药明康德生命化学研究奖、吴文俊人工智能自然科学奖、微众学者奖，华夏医学科技奖等。',
          },
          {
            name: '吕晖',
            group: '上海交通大学',
            email: 'huilu@sjtu.edu.cn',
            description:
              '吕晖，上海市计算机学会生物信息学专委会副主任。上海交通大学生物信息与生物统计系特聘教授和系主任，上海交大-耶鲁大学生物统计与数据科学中心联席主任，上海市特聘专家，上海市儿童精准医学大数据工程技术中心执行主任，国家重点研发计划首席科学家。长期从事生物信息、生物统计、医学人工智能研究。在分子组学大数据分析、生物大分子结构功能研究、临床研究以及疾病辅助诊断领域有多项原创成果以及专利。开发了生物医学数据分析全流程平台BMAP，以及罕见病辅助诊断平台diseaseGPS。累计发表文章120余篇，引用超过10000次。',
          },
          {
            name: '潘煜',
            group: '上海外国语大学脑机协同信息行为教育部重点实验室',
            email: '13311887777@163.com',
            description:
              '潘煜，上海市计算机学会生物信息学专委会副主任。二级教授、博士生导师，担任脑机协同信息行为教育部重点实验室主任。先后入选长江学者特聘教授、青年长江学者、国家百千万人才工程、国家有突出贡献中青年专家、国务院政府特殊津贴专家、上海市特聘教授(东方学者) 、教育部“新世纪优秀人才支持计划”等。长期从事脑机协同的方法研究信息行为的问题，包括类脑商业计算、信息茧房等。主持国家自科重点、科技创新2030--“脑科学与类脑研究”重大等各类课题30余项，在Nature Human Behavior、NeuroImage、Human Brain mapping、Psychiatry Research 、Information Processing and Management、Decision Support Systems等期刊，发表论文60余篇，获吴文俊人工智能科技进步奖、浙江省科技进步奖、蒋一苇奖、中国信息经济学奖等；科研育人获国家教学成果二等奖3项。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '熊毅',
            group: '上海交通大学',
            email: 'xiongyi@sjtu.edu.cn',
            description:
              '熊毅，上海市计算机学会生物信息学专委会秘书长。上海交通大学生命科学技术学院/张江高等研究院研究员，博士生导师。上海创智学院兼职导师。教育部“青年长江学者”。主要从事人工智能驱动的生物大分子功能预测与设计、药物发现与疫苗设计等研究方向。主持国家重点研发计划课题/子课题、国家自然科学基金面上项目等科研课题。以通讯作者在Nature Machine Intelligence等期刊发表研究论文多篇。',
          },
        ],
      },
    ],
  },
  {
    name: '协同与信息服务专业委员会',
    description:
      '上海市计算机学会协同与信息服务专业委员会汇聚了来自高校、企业、研究所等的学者、专家，共同对人机物深度融合背景下的协同与社会计算、信息处理与智能服务的技术和应用进行探讨，推进技术的发展和落地。专委会每年举办技术报告会、论坛、企业交流、科普等形式多样的活动，吸引各行业的专业人士，搭建桥梁、创造机会、扩大影响。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '曹健',
            group: '上海交通大学',
            email: 'cao-jian@sjtu.edu.cn',
            description:
              '曹健，上海交通大学长聘教授、博导，网络与服务计算研究所所长，主要研究方向为智能数据分析，协同信息系统，网络与服务计算、分布式人工智能。主持多项国家重点研发计划课题、国家自然科学基金课题，上海市科委重点项目。获得省部级科技进步特等、一等、二等等各类科技奖项9项，入选教育部新世纪优秀人才资助计划。在国内外发表论文300多篇。目前为IEEE高级会员，中国计算机学会杰出会员。担任上海市计算机学会协同与信息服务专委会主任，上海市人工智能学会可信人工智能系统专委会副主任，中国计算机学会协同计算专委会常务委员。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '刘静',
            group: '华东师范大学',
            email: 'jliu@sei.ecnu.edu.cn',
            description:
              '刘静是华东师范大学软件工程学院教授、博士生导师，教育部“可/信软件国际联合实验室”主任，法国爱斯特尔公司（Esterel Ltd.）- 华东师范大学的“模型驱动式轨交软件研发联合实验室”主任。获教育部“自然科学一等奖”（基于模型的可信软件理论与开发方法）。主要研究协同计算模型、安全攸关软件构造理论及技术、软件建模与验证。',
          },
          {
            name: '卢暾',
            group: '复旦大学计算机科学技术学院',
            email: 'lutun@fudan.edu.cn',
            description:
              '卢暾，复旦大学计算机科学技术学院教授、博导、副院长，上海市数据科学重点实验室副主任，复旦大学社会计算研究中心主任，美国卡耐基梅隆大学（CMU）访问学者。现为中国计算机学会杰出会员、协同计算专委秘书长，上海市计算机学会协同信息服务专委会副主任；国家政法智能化技术创新中心专家委员会社会治理领域专家，之江实验室智能社会治理实验室学术委员会委员，教育部国家发展与智能治理综合实验室研究员，多项科技部重点研发计划项目咨询专家等。研究方向为社会与协同计算、人智协同与交互、大模型智能体模拟推演、领域大模型与应用、群智协同与系统、数字社会智能治理等。作为项目负责人承担多项自然科学基金项目、科技部重点研发计划课题、863课题和上海市项目。研究成果发表在UbiComp、CSCW、CHI、NeurIPS、WWW、SIGIR、IEEE TKDE、ACM TOIS等领域权威会议和期刊上，获得过包括CSCW’15和CSCW’18在内的最佳论文（提名）奖5次。常规担任CSCW、CHI等的AC，担任多个国内外知名学术会议的程序委员会（共同）主席，以及多个国内外学术期刊的副主编和编委。',
          },
          {
            name: '邹国兵',
            group: '上海大学',
            email: 'gbzou@shu.edu.cn',
            description:
              '邹国兵，教授，博士生导师，上海大学计算机工程与科学学院副院长。入选上海市东方英才计划拔尖项目、中国计算机学会高级会员、中国计算机学会服务计算专委会执行委员、上海市信息学会第五届理事会理事、上海市计算机学会协同与信息服务专委会副主任、曾担任上海市计算机学会人工智能专委会秘书长。曾作为国家公派留学人员，在美国华盛顿大学（Washington University in St. Louis）计算机科学与工程系人工智能实验室，从事两年智能服务软件研究工作。主要从事服务计算、边缘计算、数据挖掘与智能算法、推荐系统、网络与信息安全等方向的研发工作，发表了学术论文120余篇。作为项目负责人，主持科技部国家重点研发计划项目（课题）、国家自然科学基金项目（面上、青年）、上海市自然科学基金项目（面上、青年）、教育部博士点基金项目、上海市教委科研创新项目和上海高校青年教师培养计划。担任中国计算机学会服务科学国际会议组委会主席（ICSS 2018）和出版主席（ICSS 2020）、IEEE大数据国际会议副主席（IEEE BigData 2021）、中国数字服务大会（China Service 2021、2022）顶会顶刊学术论坛主席、CCF服务计算学术年会（CCF NCSC 2023）程序委员会共同主席等。',
          },
          {
            name: '刘钦源',
            group: '同济大学',
            email: 'liuqy@tongji.edu.cn',
            description:
              '刘钦源，同济大学电子与信息工程学院教授、博导。入选国家优青、上海晨光学者。2012年本科毕业于华中科技大学，2017年博士毕业于清华大学，获清华大学优秀博士学位论文一等奖、中国自动化学会优秀博士学位论文奖、清华大学优秀毕业生等荣誉。2014-2016年间多次赴香港科技大学电子及计算机工程学系从事研究工作，2016-2017年赴布鲁奈尔大学计算机科学系任国际研究员，2021-2022年于工业和信息化部产业发展促进中心任国家重点研发计划项目主管。研究方向包括多传感器数据融合、异常检测和故障诊断、大数据分析和机器学习等。主持/参与国家自然科学基金、国家重点研发计划、科技创新2030“新一代人工智能”重大项目等10余项国家及省部级项目。出版Spinger专著1部，发表论文40余篇，IEEE汇刊及一区论文20余篇，5篇论文入选ESI高被引论文。曾获北京市自然科学二等奖、北京市麒麟科学技术奖、吴文俊人工智能科学技术优秀青年奖、ACM上海新星奖、世界人工智能大会青年优秀论文提名奖等荣誉。担任Control Eng Pract、Int J Syst Sci等5个国际期刊客座编辑/副编辑/编委，10余个国际会议副编辑/程序委员会委员/邀请组主席，20余个国内外期刊及会议的审稿人。担任中国人工智能学会青工委、中国自动化学会故障诊断专委会、中国指挥与控制学会智能控制与系统专委会、中国电子学会区块链分会等多个二级学会委员；国家自然科学基金、国家重点研发计划、上海市科技进步奖与技术发明奖评审专家。',
          },
          {
            name: '丁富强',
            group: '上海理想信息产业（集团）有限公司',
            email: 'dingfuqiang.sh@chinatelecom.cn',
            description:
              '丁富强，2002年毕业于上海交通大学并获博士学位，教授级高工，上海理想信息产业（集团）有限公司 技术总监、上海互联网大数据工程技术研究中心 执行主任；上海市优秀技术带头人，主要从事大数据、云计算及工业互联网等领域的产品开发与应用推广工作。承担多个国家科技部、国家发改委、上海市科委、上海市经信委等专项课题研究；先后获上海科技进步一等奖一项、三等奖二项，上海技术发明二等奖一项，中国通信学会三等奖一项。获得发明专利六项，参编国家标准四项。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '戴伟辉',
            group: '复旦大学',
            email: 'whdai@fudan.edu.cn',
            description:
              '戴伟辉，复旦大学管理学院教授、全球全媒体研究院研究员、博士生导师，美国麻省理工学院斯隆管理学院、美国哥伦比亚大学医学院访问学者，中国计算机学会杰出会员。担任上海市计算机学会协同与信息服务专业委员会秘书长、管理科学与工程学会常务理事、神经管理与神经工程分会主任委员、中国系统工程学会应急管理专业委员会常务委员、中国计算机学会协同计算专业委员会执行委员、中国人工智能学会社会计算与社会智能专业委员会委员、中国文化产业管理专业委员会常务理事、中国医师协会腔内血管学专业委员会第一届研究与转化专家委员会副主任委员和上市公司独立董事。主要研究方向为神经管理与神经工程、人机混合智能、社交媒体分析与社会计算，主持国家863计划课题、国家重点研发计划课题、教育部哲学社会科学重大项目、国家自然科学基金项目、国家社会科学基金项目、国家重点新产品项目、上海人民政府决策咨询研究重点课题等国家级与省部级项目26项，作为第一完成人获得全国商业科技进步奖一等奖、上海市科技进步奖二等奖、吴文俊人工智能科技进步奖二等奖等科技成果奖励16项。',
          },
        ],
      },
    ],
  },
  {
    name: '存储专业委员会',
    description:
      '上海市计算机学会存储专委是上海市计算机学会下设的专业委员会之一，主要专注于存储领域的前沿技术研究，成员由高校、研究所的专家学者及企业从事计算机存储技术创新的专家和技术骨干组成。广泛涉及存储各个领域包括存储架构、存储优化、分布式存储、存储安全及存储智能化、DNA新兴存储等方向。存储专委致力于推动存储技术的学术研究、技术创新和产业发展，加强产学研合作，促进存储技术在各行业的广泛应用。上海市计算机学会存储专委将会持续推动上海地区乃至全国的存储技术发展，构建一流的存储技术创新与合作平台，为中国在全球存储技术中的竞争力增光添彩。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '吴晨涛',
            group: '上海交通大学',
            email: 'wuct@cs.sjtu.edu.cn',
            description:
              '上海交通大学计算机科学与工程系教授、博导，为国家级青年人才，国家重点研发计划首席科学家，华中科技大学、美国弗吉尼亚联邦（州立）大学双博士。CCF体系结构专委会常委。研究方向主要为云存储、大数据存储系统。主持国家重点研发计划、国家自然科学基金、上海市自然科学基金等项目20余项，在IEEE TC、IEEE TPDS、ATC、HPCA、DAC等期刊会议上发表论文100余篇。研究成果荣获2019年国家技术发明二等奖、2018年和2022年上海市技术发明一等奖。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '陈雪菲',
            group: '上海羲容科技有限公司',
            email: 'ericchan@163.com',
            description:
              '上海羲容科技联席CTO，大数据云计算领域的资深专家，专注于数据存储技术的研究与应用，致力于推动国产存储行业的发展。多次参与国内重大项目，产生了深远的行业影响力，尤其在技术要求极高的电信行业。曾在上海电信研究院和视讯中心主持多个前沿存储技术研究与落地项目，包括分布式存储研究项目和HTTP直存技术标准研究项目。',
          },
          {
            name: '石亮',
            group: '华东师范大学',
            email: 'lshi@cs.ecnu.edu.cn',
            description:
              '华东师范大学，教授，博士生导师，上海市科技启明星，CCF YOCSEF上海2025-2026主席。研究兴趣主要针对智能计算机系统，包括大数据与云计算、移动嵌入式终端等。长期从事智能系统的存储系统建设，在闪存存储系统方面做出了大量的系统性的研究工作。研究工作获得了国家自然科学基金、国家863计划、上海市科委基金以及企业的资助，研究成果在包括FAST、ATC、MICRO、HPCA、DAC、MSST、TC、TCAD等系统领域国际权威期刊和会议上发表百余篇，ACM TECS, CCF THPC, JSA等期刊特刊主编，TC、TPDS、TCAD、DAC、ASP-DAC等国际期刊和会议的审稿人和会议程序委员会成员。',
          },

          {
            name: '殷树',
            group: '上海科技大学',
            email: 'yinshu@shanghaitech.edu.cn',
            description:
              '殷树2012年获得美国奥本大学计算机科学博士学位，同年于湖南大学任助理教授，2014年于国防科技大学HPCL从事在职博士后工作，2015晋升为副教授。2016年全职加入上海科技大学，现任常聘副教授（tenured）、MHPC联合实验室主任。研究领域包括并行与分布式文件系统、高性能计算系统、系统节能及可靠性分析。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '王春东',
            group: '上海科技大学',
            email: 'wangc@shanghaitech.edu.cn',
            description:
              '王春东目前任上海科技大学助理教授、研究员、博士生导师，信息学院系统与安全中心主任。2008年毕业于西安交通大学计算机科学与技术系，获得学士学位。随后赴新加坡国立大学计算机学院攻读博士学位，于2013年毕业。王春东先后在新加坡数据存储研究院和新加坡科技设计大学工作。他已发表同行评审论文和专利40余篇，其中CCF A类文章17篇、B类16篇，包括IEEE TC, IEEE TDSC, ACM TOS, ACM TECS, USENIX ATC, USENIX FAST, USENIX Security, DAC, SC等。王春东的研究方向有计算机存储、体系结构和数据安全与隐私等。',
          },
          {
            name: '薛栋梁',
            group: '上海交通大学',
            email: 'xuedongliang010@sjtu.edu.cn',
            description:
              '薛栋梁现为上海交通大学计算机科学与工程系副研究员，主要研发方向为工业软件，系统软件，分布式系统及云计算。发表CCF A类会议论文及期刊论文多篇，获得2020年度上海市技术发明奖一等奖，排名第6。主持“面向物联网应用的泛在操作系统实现方法及其关键技术研究”和“面向非易失内存的页面动态管理机制研究”。',
          },
        ],
      },
    ],
  },
  {
    name: '网络专业委员会',
    description:
      '上海市计算机学会网络专委会成立于2015年10月，是根据上海计算机网络及其应用领域迫切需要而建立的学术组织，受上海计算机学会的直接领导。是计算机网络相关专业研究和技术人员与单位的学术组织。专委会致力于促进网络领域的学术交流，增强与国际网络学术组织的交往，推动上海和我国网络及其应用基础理论和关键技术研究和相关技术人才的培养，使上海在计算机网络基础理论、工程技术和设施建设上有所突破。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '朱弘恣',
            group: '上海交通大学',
            email: 'hongzi@sjtu.edu.cn',
            description:
              "朱弘恣，男、博士，上海交通大学教授、博士生导师，上海市计算机学会网络专委会副主任、青年工作委员会委员。入选2018年度教育部青年长江学者奖励计划。2009年于上海交通大学获得工学博士学位，获得上海市优秀博士学位论文；2010年和2011年分别赴香港科技大学计算机科学与工程系、加拿大滑铁卢大学电子与计算机工程系从事博士后研究工作；2011年加入上海交通大学计算机科学与工程系。任《IEEE Transactions on Distributed and Parallel Systems》、《IEEE Transactions on Vehicular Technology》和《IEEE Internet of Things Journal》编委。主要研究方向为物联网、移动计算，累计发表CCF A类论文50余篇。获得IEEE GLOBECOM'16、ACM SenSys’24最佳论文奖；2021年CCF自然科学一等奖。",
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '李重',
            group: '东华大学',
            email: '007lizhong@dhu.edu.cn',
            description:
              '李重，女、博士，东华大学教授、博士生导师，2015年博士毕业于同济大学“嵌入式系统与服务计算”教育部重点实验室计算机软件与理论专业。现任东华大学信息科学与技术学院通信系教授，博导、硕导，担任通信系系主任职务。目前担任上海市计算机学会网络专委会副主任、CCF物联网专委委员、CCF互联网专委委员和CCF网络与数据通信专委委员。所指导的硕士研究生多次获上海市市级优秀毕业生，全国数学建模竞赛二等奖等奖项。',
          },
          {
            name: '杨恺',
            group: '同济大学',
            email: 'kaiyang@tongji.edu.cn',
            description:
              '杨恺，男、博士，同济大学教授、博士生导师，分别在东南大学, 新加坡国立大学, 美国哥伦比亚大学获得学士, 硕士,和博士学位。曾经在美国哥伦比亚大学，贝尔实验室, NEC 美国研究所，美国华为研究院等多个高校和研究院从事教学和研究工作。曾任美国哥伦比亚大学客座教授。主要研究领域包括大数据，人工智能，无线通信和物联网。已在IEEE Transactions等高水平国际学术杂志上至今发表论文60余篇，并拥有30余项美国和世界专利。主持开发的网络大数据系统已经被多个顶级运营商使用。获美国哥伦比亚大学 Elihau Jury Award, 美国贝尔实验室最佳研究团队奖, 美国华为杰出研究员和未来之星等多个奖项。担任多个国际期刊的编辑和客座编辑，并曾经担任多个世界知名学术会议的技术分会主席。',
          },
          {
            name: '唐前进',
            group: '公安部第三研究所',
            email: 'tangqianjin@gass.ac.cn',
            description:
              '唐前进，公安部第三研究所博士、三级研究员,先后从事警用装备、物联网及大数据等研究与应用，参与低慢小防控、警用装备发展、公安物联网、科技兴警等专项规划工作，先后牵头承担国家级省部级项目6项，发表论文10余篇、获得授权专利6项，参与制修订标准30余项，获得公安部科技奖励1项，公安部部级津贴获得者，被中国警察协会、上海市科委等部门聘为技术专家，兼任中国计算机学会安全专委会副秘书长、TC284委员等学术职务。',
          },
          {
            name: '陈阳',
            group: '复旦大学',
            email: 'chenyang@fudan.edu.cn',
            description:
              '陈阳，男、博士，复旦大学教授、博士生导师，2004年于清华大学电子工程系获学士学位，2009年7月于清华大学电子工程系获博士学位，2009年9月至2011年4月在德国哥廷根大学计算机科学研究所从事博士后研究，2011年4月至2014年9月在美国杜克大学计算机科学系从事博士后研究。2014年10月起在复旦大学计算机科学技术学院工作，现任教授、博士生导师、上海市智能信息处理重点实验室副主任。主要研究方向包括社会计算、计算机网络及数据挖掘。先后获Amazon Web Services (AWS) in Education Research Grant Award、Microsoft Azure Research Award、2020-2021年度美团科研合作探索奖、2021年度上海市计算机学会科学技术奖三等奖、CAAI第七届全国大数据与社会计算学术会议(BDSC 2022)最受欢迎论文奖、2022年度上海市计算机学会教学成果奖三等奖、2023年度上海开源创新卓越成果奖特等奖，入选上海市浦江人才计划、诺基亚访问教授(芬兰)。',
          },
          {
            name: '王朝栋',
            group: '上海帝焚思信息科技有限公司',
            email: 'fallen@dfsecurity.cn',
            description:
              '王朝栋，现任上海帝焚思信息科技有限公司总经理，同济大学博士；具有10年以上网络安全战略规划、政策标准、技术产业等研究工作经验，现为上海市计算机学会网络专委会副主任，工信部工业互联网入库安全专家，上海市科委入库安全专家、上海市经信委入库安全专家；参与组织推进工业互联网安全、医疗健康网络安全、车联网安全、5G安全等行业安全的政策制度、标准、评测评估等工作，牵头承担或参与工信部、科技部、发改委、上海市政府等多个安全方向重大专项，发表了多篇核心期刊论文及获得多项发明专利。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '陈奕超',
            group: '上海交通大学',
            email: 'yichao@sjtu.edu.cn',
            description:
              '陈奕超，男、博士，上海交通大学特别副研究员。2015年毕业于美国德州大学奥斯汀分校计算机系，曾于美国AT&T Research Labs和华为香港未来网络实验室从事大数据分析；2017年接受美国国家科学基金资助，于美国奥斯汀成立Hauoli新创公司，将声波定位技术普及至手机及智能音箱，提供新型态的人机交互方式。2018年，加入上海交通大学计算机系，从事信息物理系统(Cyber-Physical Systems)的研究，结合他在大数据分析、无线网络和人机交互的研究及产业经验，落地到智能医疗、物联网、智能家庭等系统的开发与研究。陈奕超博士的多项研究成果已发表于MobiCom, UbiComp, SigComm, MobiSys等计算机领域国际会议。',
          },
        ],
      },
    ],
  },
  {
    name: '多媒体专业委员会',
    description:
      '多媒体技术的研究领域包括：多媒体信息处理；多媒体数据压缩编码；多媒体内容分析与检索技术；多媒体交互与集成；多媒体通信与网络；多媒体内容安全；多媒体系统与虚拟现实等。当前，多媒体技术呈现出与计算机体系结构、计算机网络、人机交互、信息安全、社会网络等多学科交叉融合的发展趋势。专委会希望成为多媒体技术领域上海与国内外、学术界与产业界、业内专家与广大科研人员交流合作的桥梁，通过专委的工作，推动本学科的建设和发展，促进青年人才的成长，并承担多媒体技术相关教育、知识的普及等社会服务。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '陈智能',
            group: '复旦大学',
            email: 'zhinchen@fudan.edu.cn',
            description:
              '陈智能，复旦大学计算机科学技术学院研究员、博士生导师，上海人工智能实验室双聘青年研究员，上海市智能视觉计算协同创新中心副主任，兼任上海市计算机学会多媒体专委会主任，中国图象图形学学会多媒体专委会委员、副秘书长，主要科研方向为多媒体分析与检索、计算机视觉、生物医疗图像分析。作为负责人承担了项国家重点研发计划课题和国家自然科学基金项目，以及多项百度、腾讯、阿里巴巴、软控等知名企事业单位的科研项目，所研发技术系统部署应用于国家相关部门和多个行业领先企业。在TPAMI、IJCV、CVPR、ICCV、ECCV、AAAI、IJCAI、ACM MM、TMM、计算机学报等国内外知名学术期刊和会议上发表论文80多篇。担任ACM MM、AAAI等多个权威国际会议的领域主席、高级程序委员等，以及TPAMI等多个知名国际期刊的审稿人。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          // {
          //   name: '何高奇',
          //   group: '华东师范大学',
          //   email: 'gqhe@cs.ecnu.edu.cn',
          // },
          {
            name: '纪达麒',
            group: '达观数据有限公司',
            email: 'jidaqi@datagagrand.com',
            description:
              '纪达麒，达观数据首席技术执行官（CTO），人工智能高级工程师，上海首批一级人工智能训练师，中国计算机学会（CCF）和国际电子电器工程师学会（IEEE）会员，复旦大学计算机学院校外硕士生导师。专注于自然语言处理、数据挖掘、信息检索等领域的AI技术。曾任盛大文学技术总监，搜狗系统架构师，百度工程师等职务。曾多次参加ACM KDD-Cup，CIKM Cup等世界一流数据挖掘竞赛并获胜，申请有发明专利25项专利，是广东省科学技术奖科技进步奖、浦东新区科技进步二等奖、浦东新区技能人才、张江国家自主创新示范区杰出创新人才等荣誉称号获得者。',
          },
          {
            name: '邹丹平',
            group: '上海交通大学',
            email: 'dpzou@sjtu.edu.cn',
            description:
              '邹丹平，上海交通大学研究员，2010年于复旦大学计算机学院获得博士学位，2010年-2013年于新加坡国立大学进行博士后研究。2013年加入上海交通大学感知与导航研究所，期间先后担任助理研究员、副教授、研究员。他的研究方向聚焦于智能无人系统的视觉感知与导航技术。代表成果有面向多无人系统的协同视觉SLAM、基于环境几何结构化信息的视觉SLAM与视觉惯性融合里程计、基于文本语义的SLAM等方法。先后主持自然科学基金青年项目、面上项目等国家级项目并担任相关领域专家。并于2014年创办“智在飞翔”智能无人机技术竞赛。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '戈维峰',
            group: '复旦大学',
            email: 'wfge@fudan.edu.cn',
            description:
              '戈维峰，复旦大学计算机科学技术学院青年副研究员、硕士生导师，复旦大学计算与智能创新学院领军人才班班导师。2025年当选中国计算机学会青年精英论坛YOCSEF上海学术秘书，2024年当选上海计算机学会多媒体专委会秘书长。主要从事计算机视觉、认知科学和人形机器人相关研究。以第一或通讯作者在TOG、ICCV、CVPR、NeurIPS等人工智能领域高水平期刊和会议发表论文30多篇。担任《IEEE TCSVT》、《IEEE TNNLS》、CVPR、ICCV、NeurIPS、AAAI、ICLR等重要会议期刊审稿人。主持国家自然科学基金委青年项目、上海市科学技术委员会“浦江人才计划”、上海市科委新一代信息技术重点专项等项目，并参加科学技术部重点研发计划课题多项。',
          },
        ],
      },
    ],
  },
  {
    name: '系统结构专业委员会',
    description:
      '计算机系统结构涵盖传统的计算机组织结构、芯片级微体系结构、跨时空网络体系结构等。系统结构专委会致力于团结、联合、组织在计算机系统结构领域从事科学研究、技术实现、产业部署的专业人士与学生队伍，开展国内外学术交流、多类型科研合作等相关活动，提高上海市计算机系统结构领域的科研、教学、应用水平，促进研究成果的产业化，提升上海市在计算机系统结构领域的科技创新能力和学术影响力。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '唐飞龙',
            group: '华东师范大学',
            email: 'fltang@dase.ecnu.edu.cn',
            description:
              '上海交通大学计算机学院教授，博导。主要从事天地一体化信息网络、人工智能、云计算等研究。发表学术论文200余篇，包括CCF A/B类论文近60篇、JCR一区论文14篇、国际会议最佳论文奖7项。\n' +
              '主持国家自然科学基金9项（其中重点1项），科技部863项目，上海市“科技行动创新计划”基础研究重点项目、人工智能领域项目等。产学研成果显著，多项技术成功应用，为企业解决了多项技术难题。\n' +
              '以第一完成人获得上海市自然科学二等奖（2019）、中国产学研合作创新成果二等奖（2022）、IEEE 可扩展计算技术委员会中期职业成就奖(IEEE TCSC MCR 2019)。获得日本学术振兴会特别研究员（JSPS Research Fellowship），上海浦江人才计划（A类）等。入选英国工程技术学会会士（IET Fellow），中国计算机学会杰出会员（CCF Distinguished Member），IEEE高级会员（Senior Member）等。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '裴颂文',
            group: '上海理工大学',
            email: 'swpei@usst.edu.cn',
            description:
              '裴颂文，上海理工大学光电信息与计算机工程学院教授，博士生导师，东方学者、浦江人才、苏州领军人才，上海市民防协会监事长。中国计算机学会理事、上海市计算机学会理事，CCF杰出会员，IEEE 高级会员。\n' +
              '曾任江苏省靖江市人民政府副市长（挂职），上海理工大学科技发展研究院副院长，杨浦区科学技术委员会副主任（挂职），美国加州大学尔湾分校访问学者，澳大利亚昆士兰科技大学高级访问学者。\n' +
              '兼任中国计算机学会CCF YOCSEF上海主席，中国计算机学会计算机工程与工艺专委会常委，中国计算机学会计算机体系结构专委会常委，上海市计算机学会体系结构专委会副主任等。荣获上海市技术发明二等奖（第一完成人）、上海市科技进步三等奖（第一完成人）、上海市教学成果一等奖、上海市计算机学会教学成果一等奖等。主要从事智能计算、异构计算、深度学习等领域研究，获得包括国家自然科学基金面上项目、上海市浦江人才、上海市自然科学基金、上海市科委专项、中科院先导科技专项子课题、国家自然科学基金重点课题、上海市经信委专项等基金资助。\n' +
              '在IEEE Trans. on SMC、 Information Sciences、ACM Trans. on Internet Technology、IEEE ESL、中国科学信息科学、计算机研究与发展、计算机学报、HPCA、DAC、ISPA、COMPSAC、ICA3PP等发表学术论文100余篇，其中ESI高被引论文2篇，合著技术专著1部，授权中国发明专利15项，授权美国发明专利2项。',
          },
          {
            name: '王英林',
            group: '上海财经大学',
            email: 'wang.yinglin@shufe.edu.cn',
            description:
              '上海财经大学计算机与人工智能学院教授，博士生导师。1998年在南京理工大学获得模式识别与智能控制博士学位，1998年至2000年在上海交通大学计算机科学与技术系进行博士后研究工作，2000年至2013年先后在上海交通大学任副教授、教授、博士生导师职务。2001年、2005年分别在香港大学、斯坦福大学进行访学研究。主持完成多个国家自然科学基金和国家科技部资助的研究项目，获上海市科技进步奖两项，研究成果在ACL、EMNLP等NLP领域国际顶会和KBS、IPM等国际重要期刊发表。多年来担任IJSEKE等期刊编委，担任PIC2021，PIC2024，IEA/AIE 2023等多个国际会议的大会主席和程序委员会主席。目前研究兴趣集中在机器学习、自然语言处理和大语言模型应用方面。',
          },
          {
            name: '孔令和',
            group: '上海交通大学',
            email: 'linghe.kong@sjtu.edu.cn',
            description:
              '孔令和，上海交通大学特聘教授，电信学院副院长，网安学院党总支书记，长江学者特聘教授，国家重点研发计划首席，国家自然科学基金重点项目负责人。长期从事物联网、空天信息、大数据、人工智能领域研究，出版专著4部，共计发表论文200余篇，获国际会议最佳论文奖15项。担任国际期刊IEEE TMC、TII、Network编委，中国电子学会理事，中国计算机学会理事。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '陈龙',
            group: '字节跳动科技有限公司',
            email: 'chenlong.sjtu@gmail.com',
            description:
              '陈龙，上海市计算机学会系统结构专委会秘书长。毕业于上海交通大学，现就职于字节跳动。 研究领域主要包括数据中心网络体系结构、软件定义网络、卫星网络和天地一体化网络等。共发表40余篇顶级国际期刊和顶级会议论文，包括CCF A类期刊IEEE TMC, IEEE JSAC, IEEE/ACM ToN等；CCF-A类会议论文USENIX ATC,  IEEE INFOCOM, IEEE ICDE,。获发明专利授权6项。论文被引用400余次。长期担任计算机体系结构、计算机网络、服务计算领域国际会议INFOCOM, IWQOS, GLOBECOM等审稿人， IEEE TMC, IEEE ToN, IEEE IoTJ等国际期刊审稿人。获得国际会议最佳论文奖两项，并获得上海市优秀毕业生和上海交通大学优秀毕业生等荣誉。',
          },
        ],
      },
    ],
  },
  {
    name: '软件工程专业委员会',
    description:
      '软工专委主要的功能为围绕软件工程领域的发展，开展学术交流、技术研讨和人才培养等活动，扩大上海市计算机学会的影响力。\n' +
      '软工专委的主要职能包括：\n' +
      '1、学术交流与技术研讨：通过“专家面对面”等活动，组织软工专委的专家或行业专家，开展软件工程领域的学术交流与技术研讨，普及软件工程领域的前沿技术和热点问题，推动软件工程技术在各行业的应用；同时，也注重加强国际交流与合作，邀请国际知名专家进行学术交流，或者协办国际学术研讨会，提升上海在软件工程领域的国际影响力；\n' +
      '2、产学研合作与人才培养：推动软件工程领域的产学研合作，通过“专委进校园”等活动，加强高校、企业、科研院所之间的联系，同时结合“软工伯乐秀”等形式，发掘软工领域的工匠、人才，促进人才培养和技术创新；\n' +
      '3、行业服务与标准制定：专注软件工程领域结合前沿新技术的技术标准和规范制定，通过“软工企业行”等活动形式，将软件测试新技术或软件工程领域新发展带进企业，为行业提供技术支持和咨询服务；\n' +
      '4、支持上海科创中心建设：围绕上海科创中心建设和数字化转型需求，开展相关技术研究和应用推广，助力上海数字经济的发展。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '蔡立志',
            group: '上海计算机软件技术开发中心',
            email: 'clz@sscenter.sh.cn',
            description:
              '蔡立志，男，博士研究生毕业，研究员，上海市东方英才（原上海市领军人才），上海市技术带头人，现任上海计算机软件技术开发中心主任，从事软件质量、信息安全相关技术研究和服务。获得发明专利授权10项，出版专著9本，审定辞典4本，发表论文135篇，编制国际、国家、军工行业等各类标准118项，其中主持的国际标准ISO/IEC 25020-2019是软件质量领域第一个由中国专家主持编制的国际标准，研制的国家标准被500多个软件测试实验室采用。2019年承担国家级科研项目《集成化众测服务平台协同研发及上海区域示范应用》。入选中组部19批博士服务团，在西宁大数据局挂职锻炼一年，荣获中共青海省委组织部颁发的“来青服务优秀博士”荣誉称号，并于2020年入选“昆仑英才”计划领军人才称号。以科技扶持西宁数字经济发展，绘就1张“数字经济”发展蓝图。荣获上海市科技进步二等奖、上海市科技进步三等奖、中国电子学会科技进步奖等多项荣誉。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '沈备军',
            group: '上海交通大学',
            email: 'Bjshen@sjtu.edu.cn',
            description:
              '沈备军，博士，上海交通大学软件学院副教授，IEEE国际软件工程知识体系SWEBOK第三版联合主编，中国首位IEEE授证的软件开发专家（CSDP）。研究方向为大模型软件技术，承担国家和省部级等科研项目50余项，在国内外学术会议和期刊上发表论文200多篇，编著教材3部。曾获霍英东教育基金会高等院校青年教师奖、上海市教学成果奖二等奖、上海市十大IT精锐提名奖、ICSE杰出论文奖等。',
          },
          {
            name: '吴毅坚',
            group: '复旦大学',
            email: 'wuyijian@fudan.edu.cn',
            description:
              '吴毅坚，博士，复旦大学计算机科学技术学院副教授，博士生导师。研究兴趣主要包括代码克隆检测与分析、软件演化分析、软件缺陷分析、软件开发大数据分析等。曾作为负责人承担国家863、973子课题、国家自然科学基金项目、全军共用信息系统装备专用技术预研项目子课题、上海市科技计划项目子课题等多项国家级及省部级科研项目，正在承担国家科学自然科学基金面上项目1项和企业合作研究项目多项，并开展成果应用。相关研究成果在软件工程领域的国内外重要会议和期刊上发表论文30余篇，曾获ACM SIGSOFT杰出论文奖、CCF技术发明二等奖、上海市教学成果二等奖等奖项。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '沈颖',
            group: '上海计算机软件技术开发中心',
            email: 'sy@sscenter.sh.cn',
            description:
              '沈颖，女，计算机应用技术硕士，高级工程师，现任上海计算机软件技术开发中心软件工程研究所所长；全国信标委云计算和分布式平台分技术委员会（SAC/TC28/SC38）委员、中国认证认可协会标准化专业技术委员会委员、上海工业数字化标准专委会委员、中国电子工业标准化技术协会第五届理事会理事、上海计算机开放系统协会第七届理事会理事。有20余年软件开发、软件测试、项目管理、软件质量保证、体系建设相关工作经验；长期以来致力于软件质量领域的科研和咨询工作；近年来，致力于新一代信息技术相关的测评技术研究。主持研制地方标准《应用软件适配信息技术应用创新环境技术规范》，参与研制软件测试、软件造价评估、能力成熟度评估等国家标准、团体标准，获得上海市科技进步二等奖1次、三等奖1次、上海市技术发明二等奖1次、中国设备监理科学技术奖二等奖1次、上海市重点产品质量攻关成果二等奖1次，出版学术著作2部。',
          },
        ],
      },
    ],
  },
  {
    name: '物联网专业委员会',
    description:
      '上海市计算机学会物联网专委会是上海市计算机学会下设的一个分支机构，主要负责物联网领域的学术交流和产学研合作。其组织机构包括主任1人、副主任5人、秘书长1人、委员16人、会员100余人。其主要功能包括科学研究交流、产业合作以及组织学生竞赛等。专委会通过组织技术研讨会、培训班和论坛，促进与国内外相关组织的合作与交流，开展物联网技术的前沿研究和应用技术的研发与推广。此外，专委会还组织教育和培训活动，提高公众对物联网的认识和理解。其职能包括引导物联网技术的发展方向，组织和协调学术活动，推动物联网技术在各行业的应用，促进技术成果的产业化。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '黄新林',
            group: '同济大学',
            email: 'xlhuang@tongji.edu.cn',
            description:
              '黄新林，博士/教授/博导，EAI Fellow，上海市青年科技启明星，上海市浦江人才，同济大学青年百人计划。2021年至今任同济大学电子与信息工程学院副院长、中国（上海）数字城市研究院副院长。现任IEEE Transactions on Vehicular Technology、Scientific Reports国际期刊编委，上海市计算机学会物联网专委会主任，上海市通信学会理事。\n' +
              '长期从事智能通信、智能感知、智能计算与安全的研究，发起了首届EAI机器学习与智能通信国际会议。已主持国家重点研发计划课题、国家自然科学基金重点项目课题、面上、青年、民航联合基金。研究面向交通领域，解决高速移动场景下通信感知计算的高效可靠交互与智能处理、确定性服务以及精准运维。研究成果发表学术论文100余篇，撰写专著3部；获得授权中国专利20余项；先后获教育部技术发明奖一等奖（排名4）、上海市技术发明奖一等奖（排名2）、城市轨道交通科技进步奖一等奖。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '王东',
            group: '上海交通大学',
            email: 'wangdong@sjtu.edu.cn',
            description:
              '王东，现任上海交通大学副教授，博士生导师。2001年2月于上海交通大学取得工学博士学位。主要研究方向：基于RFID及无线通信技术的室内定位和行为感知技术、基于位置和行为大数据的推荐系统技术与算法、嵌入式系统与智能硬件技术与软件、RFID应用工程技术与系统、现代物流信息技术与系统等。',
          },
          {
            name: '金彦亮',
            group: '上海大学通信学院',
            email: 'jinyanliang@staff.shu.edu.cn',
            description:
              '金彦亮，博士，上海大学副教授。2005年获得上海交通大学通信与信息系统专业博士学位。1997年、2000年分获西安电子科技大学电子工程学院信息处理专业学士、硕士学位。2005年起在上海大学通信与信息工程学院工作。通信学会无线专委会委员。主要从事无线宽带网络、无线传感器网络（WSNs）、具身智能和大数据等方面的研究，在无线宽带网络、WSNs网络、新能源汽车设计、自动驾驶和大数据应用等方面有较深入的研究和积累。作为项目负责人和主要技术人员，参加了企业委托项目《新能源汽车整车控制器和HIL仿真平台》、上海市重点项目《城市轨道交通智能行车监控系统信息安全关键技术研究》《无线多媒体传感器网络关键技术研究》、上海市科委重大攻关项目《无线传感器网络关键技术攻关及其在道路交通中的应用示范研究》、《面向未来移动通信的多天线解决方案及评估测试》、信息产业部重大科技攻关项目《高品质微蜂窝无线局域网系统开发项目》等二十余项国家、省部、科技和企业攻关项目，发表论文40余篇，多篇被SCI、EI收录。',
          },
          {
            name: '熊勇',
            group: '中科院上海微系统所',
            email: 'yong.xiong@mail.sim.ac.cn',
            description:
              '熊勇，博士，中国科学院上海微系统与信息技术研究所三级研究员，博士生导师，智慧应急物联网课题组组长。1996年毕业于南昌大学数学系，2003年博士毕业于上海大学运筹学与控制论专业，主要研究方向为物联网与移动通信。主持和参与了国家重点研发计划及地方重大科技攻关项目以及NOKIA、爱立信等国际企业横向合作项目近40项，在IEEE Sensors Journal、Wireless Personal Communications及IEE Electronics Letters等国际期刊上发表学术论文30余篇，获得授权发明专利20余件。在移动通信多天线方面的研究成果被写入国家工信部编制的4G技术白皮书，作为传感器和传输部分技术主编完成我国第一部地方消防物联网标准上海市工程建设规范《消防设施系统技术标准》（DG/TJ08-2251-2018）制定。2010年获“长宁区第七轮专业技术拔尖人才”荣誉称号，2020年获中国消防协会科学技术创新一等奖，2021年获中国安全生产协会安全科技进步二等奖，2022年获上海市技术发明一等奖。',
          },
          {
            name: '蒋学芹',
            group: '东华大学信息科学与技术学院',
            email: 'xqjiang@dhu.edu.cn',
            description:
              '蒋学芹，男，1981年3月出生，东华大学信息科学与技术学院教授，博导，副院长。曾先后主持国家自然科学基金青年基金和面上项目、上海市青年科技启明星、上海市自然科学基金、上海市教育委员会创新项目等纵向项目8项；参与国家科技部重大专项1项、上海市科委重大专项1项。曾担任IEEE Communications Letters副编辑。迄今，申请人已经在知名学术期刊/会议发表论文130余篇（ESI高被引论文2篇），在IEEE Transaction on Communications、IEEE Communications Letters、Science China Information Sciences、Quantum Science and Technology和Physical Review A等国际知名学术期刊发表SCI论文80余篇（ESI高被引论文2篇），授权发明专利15项（其中，已转化2项）。参与编写工信部行业标准《电信数据服务平台第12部分》、《电信数据服务平台第13部分》，以及《面向制造业的5G专网运营白皮书》。此外，申请人2011年入选“上海高校青年教师培养资助计划”，2015年入选“上海市青年科技启明星计划”等省部级及其他人才项目。',
          },
          {
            name: '王健',
            group: '复旦大学',
            email: 'jian_wang@fudan.edu.cn',
            description:
              '王健，青年研究员、博导，2013年获得高丽大学电气电子计算机工程系博士学位。曾在罗格斯大学、杜克大学、首尔国立大学从事教学科研工作。近年来在TIT、TSP、TKDE、JSTSP、JSAC、ICML、ICDE、WWW等信息领域顶刊及顶会上发文60余篇，SCI他引千余次，多篇入选ESI高被引论文。曾获IEEE信号处理协会青年最佳论文奖提名等。主持国自然面上项目、重点项目课题；国家重点研发计划课题、科技委项目、中科院开放课题、中科院交叉团队项目等。担任DCN、《应用科技》等杂志编委；中国自动化学会国防大数据专委会委员、上海市城市数字化转型标准化专家指导组成员、上海市物联网专业委员会副主任委员等。主要研究方向：压缩感知与相位恢复、图采样与图神经网络、自动驾驶多模态感知融合等。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '龚炜',
            group: '同济大学',
            email: 'weigong@tongji.edu.cn',
            description:
              '龚炜，男，同济大学助理教授。2019年博士毕业于中国科学院大学人工智能学院计算机应用技术专业，之后在加拿大西安大略大学做博士后，2021年加入同济大学。主要研究方向为移动物联网。主持国家自然科学基金一项、国家重点研发计划子课题1项，在知名学术期刊/会议发表论文30余篇，入选上海市浦江人才计划，获2023年中国自动化学会技术发明奖一等奖。',
          },
        ],
      },
    ],
  },
  {
    name: '信息安全专业委员会',
    description:
      '信息安全专委会是上海计算机学会的一个分支专委会，主要聚焦信息安全领域，是信息安全的理论研究、学术交流、技术应用的综合性平台。\n(1)信息安全前沿理论与技术的交流\n' +
      '聚焦信息安全领域的国际前沿问题，组织专家学者探索研究和交流，为信息安全技术的更新换代提供理论支持。被盗取等问题，通过研究为区块链技术的安全应用提供保障。\n' +
      '(2)信息安全与其它学科的交叉融合\n' +
      '信息安全是一个涉及多学科的领域，专委会促进计算机科学、数学、物理学、法学、管理学等不同学科之间的交叉融合，推动跨学科研究学者之间的交流合作。\n' +
      '(3)信息安全领域产学研用交流与对接\n' +
      '搭建产学研用合作平台。组织高校、科研机构与企业之间的对接活动，促进学术成果的转化。推动技术标准的形成。基于学术研究成果，联合企业和相关机构制定信息安全技术应用标准。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '刘胜利',
            group: '上海交通大学计算机系',
            email: 'slliu@sjtu,edu.cn',
            description:
              '刘胜利, 上海交通大学计算机科学与工程系教授，博士生导师，中国密码学会理事，中国密码学会数学理论专业委员会委员，全国密码专业学位研究生教育指导委员会委员。主要从事公钥密码算法和协议的设计及可证明安全的研究工作。2019 年获得国家自然基金杰出青年项目资助。在三大密会、 PKC, DCC, IEEE等国际顶会和期刊上发表多篇学术论文。2018年获得党政机要密码科技进步三等奖，2017、2019、2021、2023年分别获得中国密码学会优博论文指导教师奖。荣获2020-2021年度“上海市教育系统三八红旗手”称号。2022年获得广东省自然科学奖一等奖。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '周喆',
            group: '复旦大学计算机科学技术学院',
            email: 'zhouzhe@fudan.edu.cn',
            description:
              '周喆老师，复旦大学计算机学院青年副教授；主要研究操作系统安全、体系结构安全。论文方面，周老师2023年在USENIX OSDI发表第一作者论文，为复旦大学首篇；其余在包括S&P、CCS、Security、NDSS等操作系统、系统安全学术会议上发表论文二十余篇。学术服务方面，多次担任四大系统安全顶级会议审稿人以及ACM CCS程序委员会委员（TPC）。项目方面，主持国家自然科学基金青年基金、上海市扬帆计划、上海市自然科学基金面上项目等纵向项目，并参与国家重点研发计划课题；获得CCF-华为胡杨林基金系统软件专项、CCF-阿里巴巴AIR青年基金等横向项目支持。获奖方面，周喆老师获华为云计算方向与并行计算方向火花奖两项；并获得英特尔中国学术英才计划荣誉学者称号。',
          },
          {
            name: '温蜜',
            group: '上海电力大学计算机科学与技术学院',
            email: 'wenmi2222@163.com',
            description:
              '温蜜，上海电力大学教授、博导；中国计算机学会（CCF）杰出会员、上海市优秀学术带头人（青年）、上海市东方英才拔尖项目获得者、上海市曙光计划获得者、上海市教育系统三八红旗手等。担任“十四五”国家重点研发计划“网络空间安全治理”重点专项专家，IEEE IOT副主编，IEEE ICC, IEEE VTC等国际会议分会主席。主持了国家自然科学基金委（NSFC）联合基金重点项目、面上项目、国家重点研发计划项目子课题、上海市重点教改等20 多项科研项目。在国内外著名期刊和会议发表论文 160余 篇，发布技术标准 3 项，获得上海市科技进步奖、国网科技进步奖和中国电力创新奖等科技奖励 6 项。',
          },
          {
            name: '张磊',
            group: '华东师范大学',
            email: 'leizhang@sei.ecnu.edu.cn',
            description:
              '张磊，研究员，博士生导师，华东师范大学软件工程学院副院长；研究领域包括密码学、人工智能安全、区块链与隐私保护等。发表论文100余篇，包括IEEE TIFS、IEEE TC、IEEE TDSC、ESORICS、ASIACRYPT等国际期刊会议，研究工作获省部级二等奖和三等奖各一项。担任FGCS等多个国际期刊编委/客座编辑，100多个国际会议联合主席/程序委员会委员。主持/参与国家自然科学基金重点、面上项目，国家重点研发计划项目等20余项。入选爱思唯尔中国高被引学者、全球前2%顶尖科学家称号、上海市青年拔尖人才等；担任云安全联盟大中华区隐私科技工作组组长、中国密码学会青年工作委员会副主任、上海市计算机学会信息安全专委会副主任等。',
          },
          {
            name: '李玮',
            group: '东华大学',
            email: 'weili@dhu.edu.cn',
            description:
              '李玮，东华大学教授、博士生导师，网络计算与信息安全学科带头人、信安专业负责人,研究领域为对称密码的旁路攻击研究。荣获上海市技术发明奖一等奖、上海市科技进步奖一等奖、中国密码学会教改一等奖、中国精品科技期刊顶尖学术论文奖等荣誉，主持国家密码发展基金重点项目、国家自然科学基金项目等项目，发表TIFS、TDSC等高水平论文60余篇论文，指导学生荣获全国密码技术一等奖、上海市大学生网络安全竞赛特等奖、上海市计算机学会优秀硕士论文奖等多项奖励。',
          },
          {
            name: '魏立斐',
            group: '上海海事大学',
            email: 'Lfwei@shmtu.edu.cn',
            description:
              '魏立斐，男，汉族，1982年10月生，浙江绍兴人，中共党员，博士，现任上海海事大学计算机系教授、博士生导师，担任中国计算机学会杰出会员、中国密码学会高级会员、上海市计算机学会信息安全专委会副主任。研究领域为信息安全、隐私保护、人工智能安全、区块链、应用密码学。主持国家自然科学基金面上项目、青年项目、上海市自然科学基金面上项目等，在国内外期刊与会议上发表学术论文50余篇，论文入选“中国百篇最具国际影响力的学术论文”和“领跑者5000（F5000）——中国精品科技期刊顶尖学术论文”，获得教育部自然科学奖一等奖、上海市科学技术奖二等奖、上海市教学成果奖二等奖等省部级奖项。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '韩帅',
            group: '上海交通大学网络空间安全学院',
            email: 'dalen17@sjtu.edu.cn',
            description:
              '韩帅，上海交通大学网络空间安全学院长聘教轨副教授，博士生导师，主要从事公钥密码相关研究。针对复杂应用场景下的数据存储安全和用户隐私保护问题，深入研究可有效抵抗密钥泄漏、密钥篡改、用户渗透、依赖密钥消息等新型攻击手段的公钥密码理论，设计了多个具有高安全性、高性能、高可用性的密码方案，相关工作发表在三大密会、JoC、PKC、DCC等上。韩帅获得ACM中国新星奖、中国密码学会优秀青年奖、优博奖，并入选中国科协青托工程、上海市扬帆计划。',
          },
        ],
      },
    ],
  },
  {
    name: '理论计算机科学专业委员会',
    description: '理论计算机科学专委会聚焦与计算技术相关的理论和算法分析，为上海市以及长三角地区的相关研究人员以及业界人员提供交流平台',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '邵子瑜',
            group: '上海科技大学信息学院',
            email: 'shaozy@shanghaitech.edu.cn',
            description:
              '邵子瑜,博士，上海科技大学信息学院智能网络中心主任，长聘教授，博士生导师。现为IEEE 高级会员，上海市计算机学会理事。在北京大学获得本科与硕士学位，在香港中文大学获得博士学位。曾于2012年任美国普林斯顿大学电子工程系高级访问学者，于2017年任美国加州大学伯克利分校电子工程与计算机系访问教授, 以及伯克利Simons计算理论研究院访问科学家。长期从事信息网络领域的基础理论和关键技术研究,目前的研究方向为网络化与分布式人工智能。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '唐志皓',
            group: '上海财经大学',
            email: 'tang.zhihao@mail.shufe.edu.cn',
            description:
              '唐志皓,博士,上海财经大学计算机与人工智能学院长聘副教授，本科毕业于北京大学，博士毕业于香港大学。他的研究领域涵盖理论计算机科学与计算经济学，重点关注非完全信息下的算法设计，涉及在线算法、算法博弈论等方向。他的研究成果发表在JournaloftheACM、SIAM Journal of Computing 等国际顶级期刊，并在理论计算机科学三大顶级会议STOC、\n' +
              'FOCS、SODA上发表论文十五篇。现任上海市理论计算机科学专业委员会副主任，同时担任中国计算机学会理论计算机科学专业委员会副秘书长。',
          },
          {
            name: '张民',
            group: '华东师范大学',
            email: 'zhangmin@sei.ecnu.edu.cn',
            description:
              '张民，博士，华东师范大学软件工程学院教授、副院长，博士生导师，CCF高级会员，CCF 形式化方法专委会副主任。主要研究方向为可信软件，利用数学方法实现安全攸关系统的严格保障，目前聚焦智能系统的安全可信问题研究。研究受到国家自然基金委国际合作项目（中以）、面上项目与青年项目、华为全球创新研究计划(HIRP)、国家留学基金委以及法国高等教育署等国家级和国际合作项目的资助。相关成果发表在CAV、NeurIPS、AAAI、CVPR、ASE等国际旗舰会议。',
          },
          {
            name: '李国强',
            group: '上海交通大学',
            email: 'li.g@sjtu.edu.cn',
            description:
              '李国强博士，上海交通大学软件学院副教授，博士生导师，中国计算机学会高级会员。2001 年在太原理工大学获得工学学士学位、2005年在上海交通大学获得工学硕士学位、2008年在日本北陆先端科学大学院大学获得工学博士学位。2008年至2009年在日本名古屋大学信息科学研究科担任博士后研究员，2009年至2013年在上海交通大学软件学院担任讲师，2015年至2016年在英国牛津大学计算机科学系任访问学者，2016年至2020年在日本九州大学担任客座副教授。研究兴趣包括形式化验证、程序语言理论、知识推理与验证、智能系统验证与安全。主持国家自然科学基金四项、自然科学基金重点子课题一项。已经在国内外知名期刊和国际主流会议发表论文超百篇，包括OOPLSA、ASE、FSE、ICSE、CSCW 等顶级会议以及TSE、TSC、TII、TSMCA、TDSC、TECS等顶级期刊。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '张宇昊',
            group: '上海交通大学',
            email: 'zhang_yuhao@sjtu.edu.cn',
            description:
              '张宇昊，博士,上海交通大学长聘教轨副教授，国家海外高层次引进青年人才。博士毕业于香港大学，本科毕业于浙江大学。研究方向为理论计算机，包括在线算法设计，近似算法设计等。论文发表于理论计算机顶级会议期刊，如STOC，FOCS，SODA，JACM，SICOMP。曾主持国自然青年基金一项，获得中国运筹学会青年科技奖提名奖。',
          },
        ],
      },
    ],
  },
  {
    name: '普适计算与嵌入式专业委员会',
    description:
      '普适计算与嵌入式专委会成立于2015年3月。在普适计算方面，Mark Weiser于1991年提出了“Ubiquitous Computing（普适计算）”理念，其最初设想就是将信息技术融入到日常生活用品中，以最自然的方式提供服务。涉及的领域包括普适计算基础设施、交互模式、服务提供、终端形态、行为理解等诸多方向。在嵌入式方面涉及嵌入式微处理器、系统芯片及智能微系统、嵌入式系统设计、嵌入式软件工程、嵌入式系统应用技术等专业方向，以及可信嵌入式计算、开源嵌入式软硬件、物联网技术、信息物理融合系统等前沿领域。\n' +
      '专委会是由来自产、学、研等机构的100余位专业委员组成，致力于传播普适计算与嵌入式系统科学与技术相关新成果和新理念，推动全国范围相关专业人士合作交流，加速相关成果产学研用互动转化。为国内外相关领域的专家、学者、工程师、技术管理者和研究生提供学术研讨和技术交流平台。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '吴帆',
            group: '上海交通大学',
            email: 'fwu@cs.sjtu.edu.cn',
            description:
              '吴帆，博士，上海交通大学教授，博士生导师，国家杰出青年科学基金获得者，上海交通大学计算机科学与工程系系主任。长期从事端边协同智能、分布式系统、移动计算等方面的研究。提出子模型拆分联合学习、端侧样本跨域增强与训练效用度量、时效敏感边缘计算资源调度、端边云协同大规模分布式学习与推理方法等，成果应用于阿里巴巴端智能系统等。承担科技创新2030—人工智能重大项目、国家重点研发计划课题、国家自然科学基金、装发重大基础研究课题、军委科技委创新专项、教育部联合基金等科研项目20余项。已在国际顶级学术会议和期刊，如MOBICOM、OSDI、KDD、ICDE、INFOCOM、AAAI、IJCAI、TMC、TON、TKDE、JSAC 等发表论文200 余篇，获授权发明专利22 项，出版英文专著1 部。担任国际权威期刊TMC、TOSN、COMNET、JCST 等编委和中国计算机学会通讯专题编委。获教育部自然科学奖一等奖2项、上海市科技进步奖一等奖1项，中国计算机学会青年科学家奖、ACM 中国新星奖、CCF-腾讯犀牛鸟卓越奖以及国际学术会议论文奖7项。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '成刚',
            group: '上海诺基亚贝尔股份有限公司',
            email: 'Gang_c@163.com',
            description:
              '成刚，博士，上海诺基亚贝尔宽带终端事业部负责人及党总支书记、诺基亚家庭宽带设备全球研发中心负责人、正高级工程师。毕业后进入上海贝尔，已承担固网接入及宽带设备等数百个项目研发工作，每年全球发货终端千万台，保持全球前三位市场份额。已编著或专著中英文专业图书3本，获国务院政府特殊津贴、上海智慧工匠选树一等奖、保利集团先进生产工作者、诺基亚全球发明者奖、全球贝尔实验室创新奖、保利华信五一劳动奖、浦东科技奖等；带团队获得上海市工人先锋号等多项上海市级荣誉。',
          },
          {
            name: '徐辉',
            group: '复旦大学',
            email: 'xuh@fudan.edu.cn',
            description:
              '徐辉，博士，复旦大学计算机科学技术学院副教授，博士毕业于香港中文大学，长期从事程序分析和系统软件可靠性研究，在该领域的重要国际学术会议和期刊发表多篇学术论文，获得ACM SIGSOFT杰出论文奖、上海市计算机学会自然科学奖等奖项，曾多个国际学术会议的组织委员会任职，担任DSN 2021大会宣传主席、DSML 2021会议主席、ISSRE 2024简报主席等职务。',
          },
          {
            name: '王漫',
            group: '上海第二工业大学',
            email: 'manwang@163.com',
            description:
              '王漫，博士，上海第二工业大学教授级高级工程师。中国工程教育认证专家。中国计算机学会CCF YOCSEF上海荣誉委员。曾任上海市计算技术研究所副总工程师。中国计算机学会第十一届、第十二届理事会理事。上海市计算机学会第八届、第九届理事会普适计算与嵌入式专业委员会主任。从2001年起，在国内较早地从事了无线传感器网络技术、物联网技术的研发工作。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '郑臻哲',
            group: '上海交通大学',
            email: 'zhengzhenzhe@sjtu.edu.cn',
            description:
              '郑臻哲，博士, 上海交通大学计算机科学与工程系教授，博士生导师，国家自然科学基金优秀青年科学基金获得者。2018年上海交通大学博士毕业，2016年至2019年在美国伊利诺伊大学香槟分校（UIUC）先后从事访问学者与博士后研究。主要研究领域包括移动智能计算以及大规模智能决策。已发表中国计算机学会（CCF）推荐期刊会议列表A 区50篇，荣获多项科研奖励，包括中国计算机学会（CCF）优秀博士论文奖（2018 年）；英特尔中国学术英才计划（2022年）；孙永强青年学者奖（2024年）；上海市计算机学会自然科学奖一等奖（2022年，排二）；上海市科技进步一等奖（2023年，排五）；微软学者奖学金（Microsoft Research Asia Ph.D. Fellowship，2015年）；谷歌全球博士生奖研金（Google Ph.D. Fellowship，2015年）。主持国家自然科学基金青年/面上/优青项目以及重点项目课题、科技部重点研发课题、上海市浦江人才项目。获得华为优秀学术合作项目（2023年）、阿里巴巴优秀学术合作项目（2022年）、CCF-腾讯犀牛鸟基金优秀项目（2023年）。曾担任国际学术会议INFOCOM、MobiHoc、AAAI、MSN、IoTDI等程序委员会委员。',
          },
        ],
      },
    ],
  },
  {
    name: '数据库专业委员会',
    description:
      '上海市计算机学会数据库专业委员会是根据我国近年来数据管理和大数据应用领域学术研究和应用发展的需要成立，受上海市计算机学会的直接领导。专委会成员主要包括高校及企业相关核心技术人才。专委会致力于提高我国数据管理和数据应用技术水平，跟踪世界先进技术的动态，组织开展国内外学术活动，活跃学术思想，加强国际交流合作；推进高校企业合作，促进成果转化，引导和推动我国数据管理和数据应用技术的实践；发现和培养数据管理和数据应用方面的专门人才，组织各种公开课及研讨班。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '王晓玲',
            group: '华东师范大学计算机学院',
            email: 'xlwang@cs.ecnu.edu.cn',
            description:
              '王晓玲，华东师范大学计算机科学与技术学院教授，教育部新世纪人才计划获得者。\n' +
              '主要研究领域：大数据智能分析技术及在医疗和金融领域的应用研究。在国际重要学术会议和期刊上发表篇论文150余篇， 12次获得会议优秀论文称号，出版中文专著1本、英文专著2本。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '阮彤',
            group: '华东理工大学',
            email: 'ruantong@ecust.edu.cn',
            description:
              '阮彤，华东理工大学，信息科学与工程学院计算机系 教授，自然语言处理与大数据挖掘实验室主任。主要研究领域：长期从事自然语言处理、数据治理以及知识图谱等方面的科研与应用工作，在大规模电子病历文本抽取、临床知识库，临床决策支持系统以及知识图谱等方面获得多项创新成果。以第一作者或通讯作者发表TKDE、ACL等知名期刊和会议论文几十篇。  ',
          },
          {
            name: '王鹏',
            group: '复旦大学',
            email: 'pengwang5@fudan.edu.cn',
            description:
              '王鹏，男，1979年生，教授，主要研究方向为工业大数据、智能运维。主持或主要参与科技部重点研发计划、国家青年973、自然科学重点/面上基金、上海市科委、上海市经信委的多个项目，以及微软、IBM、EMC、华为等企业的资助项目。在数据库领域顶级国际期刊与会议SIGMOD、VLDB、ICDE、SIGKDD、AAAI、TKDE等发表论文100多篇。曾担任众多国际顶级与知名学术会议的程序委员会委员，包括SIGKDD、ICDE、DASFAA、WAIM等。国际知名学术期刊VLDB Journal、TKDE、KIS等的审稿人。',
          },
          {
            name: '张敬周',
            group: '上海上科信息通信工程研究院',
            email: 'zjz@sscenter.sh.cn',
            description:
              '张敬周，男，1970年生，研究员，主要研究方向为计算机软件、智慧能源。参与或主持国家和上海市科研攻关计划20多项，获得上海市科技进步二等奖2次，发表技术论文20多篇，起草国家/行业技术标准5项。\n' +
              '主要参与的研究与成果：上海构件库及其应用、上海软件技术服务平台、大数据平台及应用、大数据质量研究与应用、电力能源数字孪生关键技术研究与应用、新能源测控技术与应用、分析仪器物联规范、地质勘探采集应用软件、上海证券交易所智能化信息集成系统等。',
          },
          {
            name: '周敏奇',
            group: '华为技术有限公司',
            email: 'zhouminqi@huawei.com',
            description:
              '周敏奇，华为凯莱实验室首席架构师，嵌入式数据库科学家。2009年毕业于复旦大学计算机系，获得博士学位。曾任华东师范大学软件学院副教授，曾获上海市科学技术奖一等奖、教育部科学技术进步奖二等奖，发表高质量学术论文40余篇，拥有多项技术发明，多次担任SIGMOD、VLDB、ICDE等程序委员会委员。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '胡卉芪',
            group: '华东师范大学',
            email: 'hqhu@dase.ecnu.edu.cn',
            description:
              '华东师范大学数据科学与工程学院，副教授,博士生导师。 主要研究方向为数据库系统与理论，主要为分布式数据库、新型硬件数据库。数据库查询优化。在VLDB、ICDE、ATC等领域国际会议与期刊上发表论文40余篇，获国家科技进步二等奖与教育部科技进步一等奖，国家级教学成果二等奖等荣誉，编著有《数据科学与工程算法基础》《云原生数据库原理与实践》等专著。',
          },
        ],
      },
    ],
  },
  {
    name: '教育信息化专业委员会',
    description:
      '教育信息化专委会的主要职能是致力于推动教育与信息技术的深度融合，提升教育教学质量和管理效率，促进教育现代化发展。其核心任务包括以下几个方面：\n' +
      '1.政策研究与建议\n' +
      '分析国内外教育信息化发展趋势，研究相关政策与标准，向有关部门提供教育信息化建设的政策建议和实施方案。\n' +
      '2.技术推广与应用\n' +
      '推动新兴信息技术（如人工智能、大数据、云计算、物联网等）在教育领域的实践与应用，支持智慧校园、在线教育平台和教育资源共享服务的建设。\n' +
      '3.学术交流与合作\n' +
      '组织相关领域的研讨会、论坛及学术活动，促进教育信息化专家、学者及从业人员的交流与合作，构建专业的知识分享平台。\n' +
      '4.资源整合与共享\n' +
      '协调优质教育资源的开发与整合，推动资源平台的建设，促进教育信息资源的公平分配与共享。\n' +
      '5.能力提升与培训\n' +
      '针对教育管理者、教师及相关技术人员开展信息化培训，提升教育系统人员的信息技术应用能力与水平。\n' +
      '6.监督评估与咨询\n' +
      '对教育信息化项目的实施进行监督和评估，提供技术支持和咨询服务，确保项目的科学性与实效性。\n' +
      '通过上述职能的履行，教育信息化专委会旨在推动教育的数字化转型，实现教育公平、资源共享与教学创新，全面提升教育服务水平。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '常潘',
            group: '上海纽约大学',
            email: 'changpan@nyu.edu',
            description:
              '上海纽约大学信息技术部主任，高级工程师，上海市计算机学会教育信息化专业委员会主任。\n' +
              '曾任上海交通大学医学院网络信息中心主任，上海社会科学院网络信息中心主任，华东师范大学网络中心副主任。\n' +
              '擅长计算机网络与系统、数据中心建设、高性能运算、计算机软件与音视频系统。主要研究方向为计算机网络安全与大数据分析。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '王伟',
            group: '华东师范大学',
            email: 'wwang@dase.ecnu.edu.cn',
            description:
              '华东师范大学数据科学与工程学院教授，上海市计算机学会教育信息化专委会副主任。CCF 杰出会员，CCF 开源发展委员会委员，工信部电子标准院开源治理标准总体组组长，木兰开源社区技术委员会委员。研究方向为开源数字生态学、计算教育学。',
          },
          {
            name: '吴新林',
            group: '上海开放大学',
            email: '3100889@qq.com',
            description:
              '上海老年大学副校长，编辑。上海市徐汇区人大代表、上海市老年教育协会常务理事、上海市计算机学会教育信息化专委会副主任。\n' +
              '“以高校分类评价引领人才培养改革的上海探索与实践”“深度老龄化背景下老年教育教育教学改革的实践与探索”项目，获2022年上海市优秀教学成果奖特等奖1项、一等奖1项。',
          },
          {
            name: '郎樱',
            group: '杨浦区教育学院',
            email: '4208770@qq·com',
            description:
              '华东师范大学教育硕士，中学高级教师。杨浦区第六届学科名教师。\n' +
              '研究方向：基础教育数字化转型。\n' +
              '上海市中小学中青年教师教学技能比赛一等奖、个人专著《真情境 真问题——高中人工智能项目化学习设计》、曾编写《学校信息化之路2.0》、《慧苑撷芳 春华秋实:中学信息科技创智课堂研究集萃》等书，参加过教育部重点课题、市级课题、相关论文和案例曾获上海高中名校慕课优秀案例一等奖、上海市基础教育信息化应用典型案例二等奖。',
          },
          {
            name: '周扬帆',
            group: '复旦大学',
            email: 'zyf@fudan.edu.cn',
            description:
              '复旦大学计算机科学技术学院教授，博导；2009年博士毕业于香港中文大学；长期从事软件系统研究，曾主持、参与多项软件系统领域的国家自然科学基金项目、973项目和科技部重点研发项目；研究成果发表于百余篇学术论文，包括近年来在OSDI、SOSP、ICSE、FSE、TOSEM、TSE等软件系统领域重要出版物发表的多篇学术论文，持有多个专利，曾获上海市、深圳市、中国计算机学会的奖项及ACM SIGSOFT杰出论文奖、ACM CSCW DEI（多元、平等与共融）奖。',
          },
          {
            name: '潘建国',
            group: '上海师范大学',
            email: 'panjg@shnu.edu.cn',
            description:
              '2009年毕业于上海大学计算机应用技术专业，获工学博士学位；现任上海师范大学信息与机电工程学院副院长（主持工作），教授/硕导，国家一流本科课程负责人。\n' +
              '主要研究方向为智能信息处理、智能教育等。多年来，共发表SCI/EI期刊论文20多篇，申请专利10多项（授权5项），主持30多项科研项目，2019、2020连续两年获“上海市产学研合作优秀项目奖二等奖”。兼任全国高等学校计算机教育研究会师范教育分会常务理事、中国计算机学会科学教育创新论坛执委、上海市计算机学会教育信息化专委会副主任、上海市二星级实验教学示范中心“人工智能STEM教育实验教学示范中心”副主任。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '孙志扬',
            group: '赛尔网络有限公司上海分公司',
            email: 'Sunzy@cernet.com',
            description:
              '九三学社社员，毕业于复旦大学电子工程系，现任赛尔网络有限公司总经理助理兼上海分公司总经理，上海计算机学会教育信息化专委员秘书长，上海高等教育学会网络专委员副主任，复旦大学基础教育人工智能创新人才共育基场指导专家。\n' +
              '在中国教育和科研计算机网（CERNET）服务体系工作超20年。自2018年开始带领团队负责上海地区教育行业用户的服务工作，在CERNET国家网络中心指导下，与上海各高校紧密合作，深入推动了下一代互联网IPv6规模部署工作在上海的落地。',
          },
        ],
      },
    ],
  },
  {
    name: '高性能计算专业委员会',
    description:
      '上海市计算机学会高性能计算专业委员会（简称“上海高专委”）成立于2021年1月，首任主任是李根国（现任上海超算中心主任），曾获2023年度上海市计算机学会优秀专委会。上海高专委现有委员32人，由上海地区高校算力中心、科研机构和企业的专家学者组成，致力于推动高性能计算领域的研究、应用与交流。通过组织学术会议和技术交流活动，搭建学术界与产业界的桥梁，推动高性能计算技术的创新与应用，为上海市乃至全国的高性能计算事业发展贡献力量。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '林新华',
            group: '上海交通大学',
            email: 'james@sjtu.edu.cn',
            description:
              '林新华现为上海交通大学网络信息中心副主任、智慧人文社科中心副主任（兼）、高级工程师、博导。博士毕业于东京工业大学，主要研究方向为高性能计算。他是上海市计算机学会高性能计算专委会主任、CCF高专委常委。担任国际期刊FGCS及国内期刊《计算机科学》编委，多次受邀审稿CCF A类期刊与会议，是IEEE Cluster 2024 （CCF-B）联合大会主席。承担并参与20多项各类科研项目，包括国家重点研发计划专题、国家自然科学基金等。发表国内外会议及期刊论文30多篇，获软件著作权20多项，获2022年国家教学成果奖二等奖（排第2），2022年上海市教学成果奖特等奖（排第3）。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '魏玉琪',
            group: '上海超级计算中心',
            email: 'yqwei@ssc.net.cn',
            description:
              '魏玉琪，现任上海超级计算中心副主任、正高级工程师。\n' +
              '超级计算创新联盟副理事长、上海市计算机学会高性能计算专业委员会副主任。毕业于上海交通大学计算机科学与工程系，主要研究方向为计算机技术与应用、大型及超大型计算机系统运维研究、开发与应用。自2001年至今，全面负责上海超级计算中心历年来所有主机系统——神威-I、神威64P、曙光4000A、曙光5000A（魔方）、蜂鸟（IBM集群）、魔方2、魔方3的架构设计、方案制订、招标采购、整体建设、业务投运及日常管理工作；参与上海超级计算中心各国家级、地方级应用项目的研究。多次受邀为国内各国家级计算中心，如国家超级计算广州中心、深圳中心、济南中心等提供系统运维技术和管理培训。多次参与如深圳超算、宁波超算、山西超算等国家超算项目的评审工作。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '胡文心',
            group: '华东师范大学',
            email: 'wxhu@cc.ecnu.edu.cn',
            description:
              '胡文心，计算机科学与技术专业博士，华东师范大学高性能计算中心主任，数据科学与工程学院教授级高级工程师。中国计算机学会高性能计算专业委员会委员、上海市计算机学会高性能计算专业委员会副主任委员兼秘书长、全国高等学校计算机教育研究会青少年分会副理事长。\n' +
              '主要从事智能数据分析、高性能计算、智慧教育及医疗交叉等方面的研究。主持及参与多项国家级、省部级科研项目，近三年以第一作者或通信作者发表SCI、CCF等学术论文二十余篇，获得多项发明专利授权和数十项软件著作权。主持和参与了多个国家科技支撑项目、国家自然科学基金项目、教育部产学研协同育人项目及国内外企事业单位合作项目。主编 “十四五”时期国家重点出版物出版专项规划图书、全国高等学校计算机教育研究会“十四五”规划教材等多本出版物。',
          },
        ],
      },
    ],
  },
  {
    name: '金融科技专业委员会',
    description:
      '上海市计算机学会金融科技专委会由华东师范大学联合复旦大学、上海财经大学，以及中银金科、国泰君安等上海金融行业龙头企业等单位发起，专委会成员主要由来自上海市高校与行业企业中金融科技领域的学者以及技术专家组成。\n' +
      '金融科技专委会聚焦上海金融数字化转型的战略需求，整合行业资源，汇聚与组织金融科技技术相关领域的各界专业人士，开展学术/技术交流、人才培养、高端培训、行业智库等相关活动，提高金融科技领域的产学研合作与产教融合人才培养，推动金融创新与转型升级，服务数字经济社会，提升在全国金融科技领域的影响力。金融科技专委会还将积极参与行业标准工作，推动金融科技行业的规范化与标准化，同时为政府部门提供决策支持和科技监管手段提升，推动金融科技在实体经济、普惠金融等领域的广泛应用，促进金融科技行业的健康发展。',
    list: [
      {
        title: '主任',
        members: [
          {
            name: '王长波',
            group: '华东师范大学',
            email: 'cbwang@dase.ecnu.edu.cn',
            description:
              '王长波，华东师范大学教授，博士生导师，现任华东师范大学数据科学与工程学院党委书记。2006年毕业于浙江大学获博士学位，2009-2010年美国纽约大学石溪分校博士后研究。曾先后担任华东师范大学软件学院副院长、计算机科学与软件工程学院常务副院长、计算机科学与技术学院党委书记。兼任上海市计算机学会金融科技专委会主任、中国计算机学会CAD&CG专委会委员、中国图学学会计算机图学专委会委员、上海市人工智能与社会发展研究副会长、上海市计算机学会常务理事。已主持国家及省部级科研项目10余项，在国内外知名学术会议和期刊上发表论文近140余篇，出版专著和教材5部。曾担任国际国内会议VINCI2019、ChinaVis2018、CAD/CG2023大会主席。曾获上海市青年科技启明星、宝钢优秀教师奖、国家教学成果奖二等奖、上海市科技进步奖特等奖、上海市申银万国奖教金、陆增镛CAD&CG高科技奖等。研究方向为大数据可视分析、智能可视媒体、金融科技等。',
          },
        ],
      },
      {
        title: '副主任',
        members: [
          {
            name: '俞枫',
            group: '国泰君安',
            email: 'yufeng@gtjas.com',
            description:
              '俞枫，博士，教授级高级工程师，行业信息化资深专家，享受国务院政府津贴。现任国泰君安证券股份有限公司首席信息官，兼任证券期货业信息技术专家委员会委员、金标委委员、证标委委员、中国金融学会金融科技专委会副主任委员、证券业协会信息技术专业委员会副主任委员、金融科技创新联盟副理事长等。作为课题负责人，承担了 "十一五"、"十二五"国家科技支撑计划、国家重点研发计划、上海市国资创新能级提升等课题研发，承接了十几项各级政府、行业在云计算、大数据、人工智能、区块链等领域的创新课题研究，主持或参与制定了近50余项行业技术标准和规范，获得省部级科技大奖32项，发表论文40余篇，是行业公认的信息化标杆、数字化转型引领者、人机同行的先行者和开放证券布道者。',
          },
          {
            name: '吕智慧',
            group: '复旦大学',
            email: 'lzh@fudan.edu.cn',
            description:
              '吕智慧是复旦大学计算机科学技术学院教授、金融科技研究院副院长，曾获上海市浦江人才，现任复旦大学-中电金信金融科技与安全校企联合研究中心联席主任，中国计算机学会数字金融分会副主任。主要研究方向为：金融科技与安全、大数据架构、网络安全、云计算等。主持国家重点研发、自科基金、科委、企业合作等多个项目，发表SCI/EI论文100多篇，其中一区、二区（A类和B类）高水平论文70多篇，申请30多项专利。先后荣获2023 中国计算机学会科技进步二等奖，中国人民银行 2022年金融科技课题三等奖，2015上海市科技进步奖一等奖。',
          },
          {
            name: '石磊',
            group: '中银金科',
            email: 'sl5259@bank-of-china.com',
            description:
              '石磊，毕业于复旦大学，现就职于中银金融科技有限公司，担任业务总监。主要研究领域为资管科技方向，将人工智能、大模型等技术引入到投资中，致力于打造中国版“阿拉丁”产品。',
          },
        ],
      },
      {
        title: '秘书长',
        members: [
          {
            name: '胡彦鹏',
            group: '华鑫股份',
            email: 'huyp@shchinafortune.com',
            description:
              '胡彦鹏，现任上海华鑫股份有限公司信息技术部总经理，高级工程师。主要研究方向：金融信息系统研发管理、金融大数据分析、高可用系统构建等。20余年从事软件开发和管理工作；先后在中科院计算所上海分所和中金所长期工作，参与或主持了上交所新一代交易系统，中金所一线通平台、飞马平台、托管服务产品，中国证监会中央监管信息平台等项目；作为主要负责人主持了两项上海市科技创新基金项目。',
          },
        ],
      },
    ],
  },
];
